import * as React from "react"
const UnsprayedGroundLarge = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      enableBackground: "new 0 0 1163 820"
    }}
    viewBox="0 0 1163 820"
    {...props}>
    <style>
      {
        ".ugl_st0{display:none}.ugl_st1{display:inline}.ugl_st3{opacity:.4;fill:#fff}.ugl_st4{stroke-linecap:round;stroke-linejoin:round}.ugl_st4,.ugl_st5{fill:none;stroke:#2d0e5e;stroke-width:4;stroke-miterlimit:10}.ugl_st11{opacity:.2;fill:#2d0e5e}.ugl_st19{fill:none;stroke:#2d0e5e;stroke-width:2;stroke-miterlimit:10}.ugl_st23{display:inline;fill:#fff}.ugl_st36{fill:#e2e2ed}.ugl_st37,.ugl_st38,.ugl_st39{stroke:#2d0e5e;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10}.ugl_st37{fill:#eb4848;stroke-linejoin:round}.ugl_st38,.ugl_st39{fill:none}.ugl_st39{stroke-linejoin:round}.ugl_st40,.ugl_st41{fill:#111616}.ugl_st41{stroke-width:1.5}.ugl_st41,.ugl_st42,.ugl_st43,.ugl_st46{stroke:#111616;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.ugl_st42{fill:none;stroke-width:1.5}.ugl_st43,.ugl_st46{fill:#111616}.ugl_st46{fill:#ded3b3;stroke:#5b480e;stroke-width:6}.ugl_st59{fill:#d9d9d9}.ugl_st60{fill:#4d4d4d}.ugl_st61,.ugl_st62{fill:#2e2e89;stroke:#2e2e89;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.ugl_st62{fill:none;stroke:#4d4d4d}.ugl_st65{display:inline;fill:#477c4e}.ugl_st68{fill:#dbf0ec}.ugl_st68,.ugl_st69{display:inline}.ugl_st69,.ugl_st77{fill:#a4aa5d}.ugl_st78{fill:#c3dd8b}.ugl_st103,.ugl_st104,.ugl_st105,.ugl_st106{fill:#a5c2d9;stroke:#a5c2d9;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.ugl_st104,.ugl_st105,.ugl_st106{fill:#072e44;stroke:#072e44}.ugl_st105,.ugl_st106{fill:#13496d;stroke:#13496d}.ugl_st106{fill:none}.ugl_st107{fill:#13496d}.ugl_st108,.ugl_st113{stroke-miterlimit:10}.ugl_st108{fill:#c0e4f3;stroke:#c0e4f3;stroke-linecap:round;stroke-linejoin:round}.ugl_st113{fill:none;stroke:#a4aa5d;stroke-width:2}.ugl_st114{fill:#477c4e}.ugl_st127{display:inline;fill:#a38065}.ugl_st129{fill:#cab798}.ugl_st130{fill:#a38065}.ugl_st131{fill:#9f7b60}.ugl_st132{fill:#825550}.ugl_st133{fill:#26662c}.ugl_st135{fill:#334724}.ugl_st136{fill:#6c5410}.ugl_st137{fill:#7ab729}.ugl_st138{fill:#edb56b}.ugl_st139{fill:#b6753a}.ugl_st145{fill:#ff461d}.ugl_st169{fill:#ffe540}.ugl_st170{fill:#e8c70f}.ugl_st172{fill:none;stroke:#e8c70f;stroke-width:6;stroke-linecap:round;stroke-miterlimit:10}"
      }
    </style>
    <g id="eko-illus_landskap_3_svg__Lager_5">
      <path
        d="M1156.9 410h-10.8c-2.1-1.9-4.5-3.6-7.2-5l-517-271.5c-25.6-13.5-56.9-13.5-82.5 0L22.5 405c-2.7 1.4-5.1 3.1-7.2 5H4.4v23.9c0 11.3 6 22.6 18.1 29l516.9 271.5c25.6 13.5 56.9 13.5 82.5 0l516.9-271.5c12-6.3 18.1-17.6 18.1-29V410z"
        style={{
          fill: "#5b361d"
        }}
      />
      <defs>
        <path
          id="eko-illus_landskap_3_svg__SVGID_00000176006292875984484160000011538169652901903254_"
          d="M-1721.1-1078.8h-923c-66.3 0-120-53.7-120-120v-580c0-66.3 53.7-120 120-120h923c66.3 0 120 53.7 120 120v580c0 66.3-53.8 120-120 120z"
        />
      </defs>
      <clipPath id="eko-illus_landskap_3_svg__SVGID_00000183242445138691912330000006133170811801832873_">
        <use
          xlinkHref="#eko-illus_landskap_3_svg__SVGID_00000176006292875984484160000011538169652901903254_"
          style={{
            overflow: "visible"
          }}
        />
      </clipPath>
      <path
        d="m-997.2-969.6-1168.2 584.1 1168.2 584.1L171-385.5z"
        className="ugl_st136"
        style={{
          clipPath:
            "url(#eko-illus_landskap_3_svg__SVGID_00000183242445138691912330000006133170811801832873_)"
        }}
      />
      <defs>
        <path
          id="eko-illus_landskap_3_svg__SVGID_00000150802189632818402920000004489806311268639106_"
          d="M-2198.5 109.5-2715.4 381c-24.1 12.7-24.1 45.3 0 57.9l516.9 271.5c25.6 13.5 56.9 13.5 82.5 0l516.9-271.5c24.1-12.7 24.1-45.3 0-57.9L-2116 109.5c-25.6-13.5-56.8-13.5-82.5 0z"
        />
      </defs>
      <clipPath id="eko-illus_landskap_3_svg__SVGID_00000033334924975400455270000010829100911114583196_">
        <use
          xlinkHref="#eko-illus_landskap_3_svg__SVGID_00000150802189632818402920000004489806311268639106_"
          style={{
            overflow: "visible"
          }}
        />
      </clipPath>
      <g
        style={{
          clipPath:
            "url(#eko-illus_landskap_3_svg__SVGID_00000033334924975400455270000010829100911114583196_)"
        }}>
        <path
          d="m-470.7-509-563.9 281.9 563.9 282 563.9-282z"
          className="ugl_st130"
        />
        <path
          d="M-1046.7 319.6 54.9-231.9l11.1 5.5-1101.7 551.5zM-1063.5 311.2 38.2-240.3l11 5.5-1101.6 551.5zM-1080.4 302.7 21.1-248.7l11.2 5.4-1101.7 551.5zM-1097.4 294.2 4.2-257.3l11.1 5.5-1101.7 551.5zM-927.8 379.1 173.9-172.4l11 5.5-1101.6 551.5zM-944.5 370.7 157.1-180.8l11.1 5.5-1101.7 551.5zM-961.5 362.2 140-189.2l11.2 5.4-1101.6 551.5zM-978.5 353.7 123.2-197.8l11 5.6-1101.6 551.5zM-995.4 345.2 106.2-206.3l11.1 5.6-1101.7 551.5zM-1012.8 336.5 88.8-215l11 5.6-1101.6 551.5zM-1029.8 328.1 71.9-223.4l11 5.5-1101.7 551.5z"
          className="ugl_st129"
        />
      </g>
      <defs>
        <path
          id="eko-illus_landskap_3_svg__SVGID_00000121960022035761954670000003152957949902822023_"
          d="M-843.6 109.5-1360.5 381c-24.1 12.7-24.1 45.3 0 57.9l516.9 271.5c25.6 13.5 56.9 13.5 82.5 0L-244.2 439c24.1-12.7 24.1-45.3 0-57.9l-516.9-271.5c-25.7-13.6-56.9-13.6-82.5-.1z"
        />
      </defs>
      <defs>
        <path
          id="eko-illus_landskap_3_svg__SVGID_00000119803472945597527310000009038233997606889377_"
          d="M539.4 109.5 22.5 381c-24.1 12.7-24.1 45.3 0 57.9l516.9 271.5c25.6 13.5 56.9 13.5 82.5 0L1138.8 439c24.1-12.7 24.1-45.3 0-57.9L621.9 109.5c-25.6-13.5-56.9-13.5-82.5 0z"
        />
      </defs>
      <clipPath id="eko-illus_landskap_3_svg__SVGID_00000035515592408811407150000015107112619959767737_">
        <use
          xlinkHref="#eko-illus_landskap_3_svg__SVGID_00000119803472945597527310000009038233997606889377_"
          style={{
            overflow: "visible"
          }}
        />
      </clipPath>
      <g
        style={{
          clipPath:
            "url(#eko-illus_landskap_3_svg__SVGID_00000035515592408811407150000015107112619959767737_)"
        }}>
        <path
          d="m129.6 573.8-197.4 98.7 197.4 98.7L327 672.5z"
          className="ugl_st130"
        />
        <path
          d="m154.6 179-197.4 98.7 197.4 98.9 197.6-98.8z"
          className="ugl_st136"
        />
        <path
          d="m536.3 172.7-197.4 98.8 197.7 98.8 197.2-98.6z"
          className="ugl_st136"
        />
        <path
          d="m338.9 271.5-197.4 98.7 197.4 98.9 197.7-98.8z"
          className="ugl_st136"
        />
        <path
          d="m239.7 415 385.7-193.1 3.8 1.9-385.7 193.1zM233.8 412l385.7-193 3.9 1.9L237.7 414zM227.9 409.1 613.5 216l3.9 1.9L231.7 411zM221.9 406.1 607.6 213l3.9 1.9L225.8 408zM216 403.1 601.7 210l3.8 2-385.6 193.1zM209.9 400.1 595.6 207l3.8 1.9L213.8 402zM204 397.1 589.6 204l3.9 2-385.7 193zM198 394.1l385.7-193 3.9 1.9-385.7 193.1zM192 391.2l385.7-193.1 3.9 2-385.7 193zM186.2 388.3l385.7-193.1 3.8 1.9L190 390.2zM180.2 385.3l385.7-193.1 3.9 2-385.7 193zM174.3 382.3 560 189.2l3.8 2-385.6 193.1zM168.3 379.4 554 186.3l3.9 1.9-385.7 193.1zM162.2 376.3l385.7-193.1 3.9 2-385.7 193zM156.3 373.3l385.7-193 3.9 1.9-385.7 193.1zM150.4 370.4l385.7-193.1 3.8 1.9-385.6 193.1zM287.2 438.8l385.7-193.1 3.9 2-385.7 193zM281.3 435.9 667 242.8l3.9 1.9-385.7 193.1zM275.4 432.9 661 239.8l4 2-385.7 193zM269.5 429.9l385.6-193 3.9 1.9-385.7 193.1zM263.5 427l385.7-193.1 3.9 1.9-385.7 193.1zM257.4 423.9l385.7-193.1 3.9 2-385.7 193zM251.5 420.9l385.7-193 3.8 1.9-385.6 193.1zM245.6 418l385.6-193.1 3.9 1.9-385.7 193.1zM334.7 462.8l385.7-193 3.8 1.9-385.6 193.1zM328.8 459.9l385.7-193.1 3.9 2-385.7 193zM322.9 456.9l385.6-193 3.9 1.9-385.6 193.1zM317 454l385.6-193.1 3.9 1.9-385.7 193.1zM311 451l385.7-193.1 3.9 1.9-385.7 193.1zM304.9 447.9l385.7-193 3.9 1.9-385.7 193.1zM299 445l385.7-193.1 3.8 1.9-385.7 193.1zM293 442l385.7-193.1 3.9 2-385.7 193z"
          className="ugl_st137"
        />
        <path
          d="M536.1-24.8 338.7 73.9l197.7 98.9 197.2-98.7z"
          className="ugl_st136"
        />
        <path
          d="M240.5 218 626.2 24.9l3.8 2-385.6 193zM234.6 215.1 620.3 22l3.9 1.9L238.5 217zM228.7 212.1 614.3 19l3.9 1.9L232.6 214zM222.7 209.1 608.4 16l3.9 2-385.7 193.1zM216.8 206.2 602.5 13.1l3.9 1.9-385.7 193.1zM210.7 203.1 596.4 10l3.9 2-385.7 193zM204.8 200.1l385.7-193 3.8 1.9-385.7 193.1zM198.8 197.2 584.5 4.1l3.9 1.9-385.7 193.1zM192.8 194.2l385.7-193 3.9 1.9-385.7 193.1zM187 191.3 572.7-1.8l3.8 2-385.6 193zM181 188.3l385.7-193 3.9 1.9-385.7 193.1zM175.1 185.4 560.8-7.7l3.8 1.9L179 187.3zM169.2 182.4 554.8-10.7l3.9 1.9L173 184.3zM163.1 179.3l385.6-193 3.9 1.9-385.7 193.1zM157.1 176.4 542.8-16.7l3.9 1.9L161 178.3zM151.2 173.4 536.9-19.7l3.9 2-385.7 193zM288 241.8l385.7-193 3.9 1.9-385.7 193.1zM282.2 238.9 667.8 45.8l3.9 2-385.7 193zM276.2 235.9l385.7-193 3.9 1.9-385.7 193.1zM270.3 233 656 39.9l3.8 1.9-385.7 193.1zM264.3 230 650 36.9l3.9 1.9-385.7 193.1zM258.2 226.9l385.7-193 3.9 1.9-385.7 193.1zM252.3 224 638 30.9l3.8 1.9-385.6 193.1zM246.4 221 632 27.9l3.9 2L250.3 223zM335.5 265.9 721.2 72.8l3.9 1.9-385.7 193.1zM329.6 262.9l385.7-193 3.9 1.9-385.7 193.1zM323.7 260 709.3 66.9l4 1.9-385.7 193.1zM317.8 257 703.4 63.9l3.9 1.9-385.7 193.1zM311.8 254 697.5 60.9l3.9 2L315.7 256zM305.7 251 691.4 57.9l3.9 1.9-385.7 193.1zM299.8 248 685.5 54.9l3.8 2-385.6 193zM293.9 245 679.5 52l3.9 1.9L297.7 247z"
          className="ugl_st137"
        />
        <path
          d="m338.9 73.8-197.4 98.7 197.6 98.8 197.2-98.6z"
          className="ugl_st136"
        />
        <path
          d="M55.4 322.5 441 129.4l3.9 2-385.7 193zM49.5 319.6l385.7-193.1 3.8 1.9L53.4 321.5zM43.5 316.6l385.7-193.1 3.9 2-385.7 193zM37.6 313.6l385.7-193 3.9 1.9L41.5 315.6zM31.7 310.7l385.6-193.1 3.9 1.9L35.5 312.6zM25.6 307.6l385.7-193.1 3.8 2-385.7 193zM19.6 304.6l385.7-193 3.9 1.9L23.5 306.6zM13.7 301.7l385.7-193.1 3.9 1.9L17.6 303.6zM7.7 298.7l385.7-193 3.9 1.9L11.6 300.7zM1.8 295.8l385.7-193.1 3.9 2-385.7 193zM-4.1 292.8l385.6-193 3.9 1.9L-.2 294.8zM-10 289.9 375.6 96.8l3.9 1.9L-6.2 291.8zM-16 286.9 369.7 93.8l3.9 1.9-385.7 193.1zM-22.1 283.8l385.7-193 3.9 1.9-385.7 193.1zM-28 280.9 357.7 87.8l3.8 1.9-385.6 193.1zM-33.9 277.9 351.7 84.8l3.9 2-385.7 193.1zM-37.8 273.9 347.9 80.8l3.8 2-385.6 193.1zM-41.7 269.9 344 76.9l3.9 1.9-385.7 193.1zM-45.6 265.9l385.7-193 3.9 1.9-385.7 193.1zM102.9 346.3l391.6-195.8 3.5 2.2-391.3 195.6zM97 343.4l392.3-196.2 3 2.4-391.4 195.7zM91.1 340.4l391-195.7 4.5 1.6L94.9 342.4zM85.1 337.5 476 141.9l3.9 1.9L89 339.4zM79.2 334.5l391-195.7 3.7 2.1L83.1 336.4zM73.1 331.4l385.7-193 3.8 1.9L77 333.4zM67.2 328.5l385.6-193.1 3.9 1.9L71 330.4zM61.2 325.5l385.7-193.1 3.9 2L65.1 327.5zM144.5 367.4l385.7-193 3.9 1.9-385.7 193.1zM138.6 364.5l390.7-195.6 5.6 1-392.5 196.5zM132.6 361.5l390.9-195.6 4.2 1.7-391.2 195.8zM126.7 358.5 517.3 163l3.9 2-390.7 195.5zM120.6 355.5l391.5-195.8 3.6 2-391.2 195.7zM114.6 352.5l391.2-195.6 4.2 1.8-391.5 195.7zM108.7 349.5l391.8-196 4 1.9-391.9 196.1z"
          className="ugl_st137"
        />
        <path
          d="m1128.6 271.7-197.4 98.7 197.4 98.7 197.4-98.7z"
          className="ugl_st130"
        />
        <path
          d="m1097.5 134.1 3.5 151.4-169.8 84.9-394.9-197.7 125.2-62.5zM-22.4 288.1-47 485.5l374 187 209.3-104.7z"
          className="ugl_st135"
        />
        <path
          d="m733.8 271.7-197.5 98.7 197.5 98.7 197.4-98.7z"
          className="ugl_st130"
        />
        <path
          d="m536.3 370.4-197.4 98.7 197.4 98.7 197.5-98.7z"
          className="ugl_st130"
        />
        <path
          d="m437.1 513.9 385.7-193.1 3.8 1.9L441 515.8zM431.2 511l385.7-193.1 3.9 1.9-385.7 193.1zM425.3 508l385.6-193.1 3.9 1.9-385.6 193.1zM419.4 505 805 311.9l3.9 2-385.7 193zM413.4 502l385.7-193 3.9 1.9L417.3 504zM407.3 499 793 305.9l3.9 1.9-385.7 193.1zM401.4 496l385.7-193.1 3.8 2L405.2 498zM395.5 493.1 781.1 300l3.9 1.9L399.3 495zM389.5 490.1 775.1 297l3.9 2-385.7 193.1zM383.6 487.2l385.7-193.1 3.8 1.9-385.6 193.1zM377.7 484.2l385.6-193 3.9 1.9-385.7 193.1zM371.7 481.2l385.7-193 3.9 1.9-385.7 193.1zM365.8 478.3l385.6-193.1 3.9 1.9-385.7 193.1zM359.7 475.2l385.7-193 3.8 1.9-385.7 193.1zM353.7 472.3l385.7-193.1 3.9 1.9-385.7 193.1zM347.8 469.3l385.7-193.1 3.9 2-385.7 193zM484.6 537.7l385.7-193.1 3.9 2-385.7 193.1zM478.8 534.8l385.7-193.1 3.8 1.9-385.7 193.1zM472.8 531.8l385.7-193 3.9 1.9-385.7 193.1zM466.9 528.8l385.7-193 3.8 1.9-385.7 193.1zM460.9 525.9l385.7-193.1 3.9 1.9-385.7 193.1zM454.8 522.8l385.7-193 3.9 1.9-385.7 193.1zM448.9 519.9l385.7-193.1 3.9 1.9-385.7 193.1zM443 516.9l385.7-193.1 3.8 2-385.6 193zM532.1 561.8l385.7-193.1 3.9 1.9L536 563.7zM526.3 558.8l385.6-193.1 3.9 2-385.7 193.1zM520.3 555.9 906 362.8l3.9 1.9-385.7 193.1zM514.4 552.9l385.7-193.1 3.8 1.9-385.7 193.1zM508.4 549.9l385.7-193.1 3.9 2-385.7 193zM502.3 546.9 888 353.8l3.9 1.9-385.7 193.1zM496.4 543.9l385.7-193.1 3.8 1.9-385.6 193.1zM490.5 540.9l385.7-193.1 3.8 2-385.6 193.1z"
          className="ugl_st129"
        />
        <path
          d="m337 454.3 396.8-198.4v-3.6L337 450.7z"
          className="ugl_st138"
        />
        <path
          d="M733.8 255.9 337 454.3v-1.4l396.8-198.4z"
          className="ugl_st139"
        />
        <path d="M526.3 351.1V376l3.2-1.9v-24.9z" className="ugl_st138" />
        <path d="M526.3 376v-24.9l1.2-.8.1 25z" className="ugl_st139" />
        <path d="m495.7 366.4.1 24.9 3.2-1.9v-24.9z" className="ugl_st138" />
        <path d="m495.8 391.3-.1-24.9 1.3-.8.1 25z" className="ugl_st139" />
        <path d="m465 381.5.1 25 3.2-1.9v-24.9z" className="ugl_st138" />
        <path d="m465.1 406.5-.1-25 1.3-.7v25z" className="ugl_st139" />
        <path d="M434.3 397v24.9l3.3-1.9-.1-24.9z" className="ugl_st138" />
        <path d="M434.3 421.9V397l1.3-.8v25z" className="ugl_st139" />
        <path d="M403.6 412.3v25l3.3-1.9-.1-25z" className="ugl_st138" />
        <path d="M403.6 437.3v-25l1.3-.7v24.9z" className="ugl_st139" />
        <path d="M372.9 427.7v25l3.2-1.9v-25z" className="ugl_st138" />
        <path d="M372.9 452.7v-25l1.2-.7.1 24.9z" className="ugl_st139" />
        <path d="m342.1 443.1.1 25 3.2-1.9v-24.9z" className="ugl_st138" />
        <path d="m342.2 468.1-.1-25 1.3-.7.1 25z" className="ugl_st139" />
        <path d="m710.4 259 .1 24.9 3.2-1.8-.1-25z" className="ugl_st138" />
        <path d="m710.5 283.9-.1-24.9 1.3-.8v25z" className="ugl_st139" />
        <path d="M679.9 274.3v24.9l3.3-1.8-.1-25z" className="ugl_st138" />
        <path d="M679.9 299.2v-24.9l1.3-.8v25z" className="ugl_st139" />
        <path d="M649.2 289.5v24.9l3.2-1.9v-24.9z" className="ugl_st138" />
        <path d="M649.2 314.4v-24.9l1.2-.8.1 25z" className="ugl_st139" />
        <path d="m618.4 304.9.1 24.9 3.2-1.9V303z" className="ugl_st138" />
        <path d="m618.5 329.8-.1-24.9 1.3-.8.1 25z" className="ugl_st139" />
        <path d="m587.7 320.2.1 25 3.2-1.9v-24.9z" className="ugl_st138" />
        <path d="m587.8 345.2-.1-25 1.3-.7v24.9z" className="ugl_st139" />
        <path d="M557 335.6v25l3.3-1.9-.1-24.9z" className="ugl_st138" />
        <path d="M557 360.6v-25l1.3-.7v25z" className="ugl_st139" />
        <path d="m337 463.6 396.8-198.4v-3.6L337 460z" className="ugl_st138" />
        <path
          d="M733.8 265.2 337 463.6v-1.4l396.8-198.4z"
          className="ugl_st139"
        />
        <path
          d="m931.2 370.4-197.4 98.7 242.3 121.1 197.4-98.7z"
          className="ugl_st130"
        />
        <path
          d="m1173.5 491.5-197.4 98.7 242.2 121.2 152.6-121.2z"
          className="ugl_st130"
        />
        <path
          d="m832 513.9 385.6-193.1 3.9 1.9-385.7 193.1zM826.1 511l385.7-193.1 3.8 1.9L830 512.9zM820.1 508l385.7-193.1 3.9 1.9L824 509.9zM814.2 505l385.7-193.1 3.9 2-385.7 193zM808.3 502l385.6-193 3.9 1.9L812.1 504zM802.2 499l385.7-193.1 3.8 1.9L806 500.9zM796.2 496l385.7-193.1 3.9 2L800.1 498zM790.3 493.1 1176 300l3.9 1.9L794.2 495zM784.3 490.1 1170 297l3.9 2-385.7 193.1zM778.4 487.2l385.7-193.1 3.9 1.9-385.7 193.1zM772.5 484.2l385.6-193 3.9 1.9-385.6 193.1zM766.6 481.2l385.6-193 3.9 1.9-385.7 193.1zM760.6 478.3l385.7-193.1 3.9 1.9-385.7 193.1zM754.5 475.2l385.7-193.1 3.9 2-385.7 193.1zM748.6 472.3l385.7-193.1 3.8 1.9-385.6 193.1zM742.7 469.3l385.6-193.1 3.9 2-385.7 193zM736.9 465.6 924.1 372l3.9 1.9-187.2 93.7zM879.5 537.7l385.7-193.1 3.8 2-385.7 193.1zM873.6 534.8l385.7-193.1 3.9 1.9-385.7 193.1zM867.7 531.8l385.6-193 3.9 1.9-385.7 193.1zM861.7 528.8l385.7-193 3.9 1.9-385.7 193.1zM855.8 525.9l385.7-193.1 3.8 1.9-385.6 193.1zM849.7 522.8l385.7-193 3.8 1.9-385.6 193.1zM843.8 519.9l385.6-193.1 3.9 1.9-385.7 193.1zM837.8 516.9l385.7-193.1 3.9 2-385.7 193zM927 561.8l385.7-193.1 3.8 1.9-385.7 193.1zM921.1 558.8l385.7-193.1 3.9 2L925 560.8zM915.2 555.8l385.6-193 3.9 1.9L919 557.8zM909.2 552.9l385.7-193.1 3.9 1.9-385.7 193.1zM903.3 549.9 1289 356.8l3.8 2-385.7 193zM897.2 546.9l385.7-193.1 3.8 1.9-385.6 193.1zM891.2 543.9l385.7-193.1 3.9 1.9-385.7 193.1zM885.3 540.9 1271 347.8l3.9 2-385.7 193.1zM968.6 582.6l385.7-193.1 3.9 1.9-385.7 193.1zM962.7 579.7l385.7-193.1 3.9 1.9-385.7 193.1zM956.8 576.7l385.6-193.1 4 1.9-385.7 193.1zM950.9 573.7l385.6-193.1 3.9 2-385.7 193zM944.9 570.7l385.7-193 3.9 1.9-385.7 193.1zM938.8 567.7l385.7-193.1 3.9 1.9-385.7 193.1zM932.9 564.7l385.7-193 3.8 1.9-385.6 193.1zM1016.3 606.5l385.7-193 3.9 1.9-385.7 193.1zM1010.5 603.6l385.7-193.1 3.8 2-385.6 193zM1004.5 600.6l385.7-193 3.9 1.9-385.7 193.1zM998.6 597.7l385.7-193.1 3.9 1.9-385.7 193.1zM992.7 594.7l385.6-193.1 3.9 1.9-385.7 193.1zM986.6 591.6l385.6-193 3.9 1.9-385.7 193.1zM980.6 588.7l385.7-193.1 3.9 1.9-385.7 193.1zM974.7 585.7l385.7-193.1 3.9 2-385.7 193zM1063.9 630.4l385.7-193.1 3.8 1.9-385.7 193.1zM1058 627.4l385.7-193 3.9 1.9-385.7 193.1zM1052.1 624.5l385.6-193.1 3.9 1.9-385.7 193.1zM1046.1 621.5l385.7-193.1 3.9 2-385.7 193zM1040.2 618.5l385.7-193.1 3.8 2-385.6 193.1zM1034.1 615.5l385.7-193.1 3.8 1.9L1038 617.4zM1028.2 612.5l385.6-193.1 3.9 2-385.7 193zM1022.2 609.5l385.7-193 3.9 1.9-385.7 193.1zM1111.4 654.4l385.7-193.1 3.8 2-385.7 193zM1105.5 651.5l385.7-193.1 3.9 1.9-385.7 193.1zM1099.6 648.5l385.6-193.1 3.9 2-385.7 193zM1093.6 645.5l385.7-193 3.9 1.9-385.7 193.1zM1087.7 642.6l385.7-193.1 3.8 1.9-385.7 193.1zM1081.6 639.5l385.7-193.1 3.8 2-385.7 193zM1075.6 636.5l385.7-193 3.9 1.9-385.7 193.1zM1069.7 633.6l385.7-193.1 3.9 1.9-385.7 193.1zM1153 675.2l385.7-193 3.9 1.9-385.7 193.1zM1147.1 672.3l385.7-193.1 3.9 2-385.7 193zM1141.2 669.3l385.6-193 4 1.9-385.7 193.1zM1135.3 666.4l385.6-193.1 3.9 1.9-385.7 193.1zM1129.3 663.4 1515 470.3l3.9 1.9-385.7 193.1zM1123.2 660.3l385.7-193 3.9 1.9-385.7 193.1zM1117.3 657.4 1503 464.3l3.8 1.9-385.6 193.1z"
          className="ugl_st129"
        />
        <path
          d="m733.8 449.5 184.3 92.8v3.6l-184.3-92.8z"
          className="ugl_st138"
        />
        <path
          d="m733.8 451.6 184.3 92.9v1.4l-184.3-92.8z"
          className="ugl_st139"
        />
        <path d="M749.2 452.4v25l-3.3-1.9.1-24.9z" className="ugl_st138" />
        <path d="M749.2 477.4v-25l-1.3-.7v24.9z" className="ugl_st139" />
        <path d="M778.7 467.1v25l-3.3-1.9.1-25z" className="ugl_st138" />
        <path d="M778.7 492.1v-25l-1.3-.7v24.9z" className="ugl_st139" />
        <path d="m808.2 481.7-.1 24.9-3.2-1.8v-25z" className="ugl_st138" />
        <path d="m808.1 506.6.1-24.9-1.3-.8v25z" className="ugl_st139" />
        <path d="m837.7 496.5-.1 25-3.2-1.9v-24.9z" className="ugl_st138" />
        <path d="m837.6 521.5.1-25-1.3-.7-.1 24.9z" className="ugl_st139" />
        <path d="M867.1 511.2v25l-3.2-1.9v-24.9z" className="ugl_st138" />
        <path d="M867.1 536.2v-25l-1.2-.7-.1 24.9z" className="ugl_st139" />
        <path d="M896.6 526.1V551l-3.3-1.8.1-25z" className="ugl_st138" />
        <path d="M896.6 551v-24.9l-1.3-.8v25z" className="ugl_st139" />
        <path d="m918.1 551.6-.1 3.3-184.2-92.5v-3.7z" className="ugl_st138" />
        <path d="m918.1 552.9-.1 2-184.2-92.5v-1.5z" className="ugl_st139" />
        <path
          d="m931.2 567.8-197.4 98.7 197.4 98.7 197.4-98.7z"
          className="ugl_st136"
        />
        <path
          d="m1128.6 666.5-197.4 98.7 197.4 98.7 197.4-98.7zM733.8 469.1l-197.5 98.7 197.5 98.7 197.4-98.7z"
          className="ugl_st136"
        />
        <path
          d="M536.3 567.8 327 672.5l197.5 98.7 209.3-104.7z"
          className="ugl_st136"
        />
        <path
          d="M596.7 542.3 917 702.7l-3.8 1.9-320.3-160.4zM598.9 541.3l320.3 160.3 3.7-1.9-320.4-160.3zM604.8 538.3l320.3 160.3 3.7-1.8-320.3-160.4zM930.9 695.7 610.8 535.3l3.7-1.9 320.2 160.4zM936.8 692.8 616.7 532.3l3.7-1.8 320.2 160.4zM942.8 689.8 622.6 529.4l3.8-1.9 320.1 160.4zM948.7 686.8 628.6 526.4l3.7-1.8 320.1 160.3zM954.9 683.7 634.5 523.5l3.9-2 320.3 160.3zM644.4 518.5l320.2 160.3-3.8 2-320.3-160.4zM646.5 517.4l320.3 160.3 3.7-1.8-320.3-160.3zM652.4 514.5l320.3 160.3 3.7-1.9-320.3-160.3zM978.5 671.9 658.4 511.5l3.7-1.9L982.3 670zM984.5 668.9 664.3 508.5l3.7-1.9L988.2 667zM990.4 666 670.3 505.5l3.7-1.8 320.2 160.4zM996.3 663 676.2 502.6l3.7-1.9L1000 661.1zM1002.6 659.9 682.1 499.6l3.9-1.9L1006.3 658zM692.5 494.4l320.3 160.4-3.9 1.9-320.2-160.3zM694.6 493.4 1015 653.7l3.7-1.9-320.4-160.3zM700.6 490.4l320.2 160.4 3.8-1.9-320.3-160.3zM1026.7 647.8 706.6 487.4l3.7-1.8 320.2 160.3zM1032.6 644.9 712.5 484.5l3.7-1.9L1036.4 643zM1038.5 641.9 718.4 481.5l3.7-1.9L1042.3 640zM1044.5 638.9 724.3 478.5l3.8-1.8L1048.2 637zM1050.7 635.8 730.3 475.6l3.9-2L1054.4 634zM551.2 565l320.3 160.3 3.7-1.8-320.3-160.3zM557.1 562l320.3 160.4 3.7-1.9-320.3-160.3zM883.2 719.5 563.1 559.1l3.7-1.9L887 717.6zM889.2 716.5 569 556.1l3.8-1.9 320.1 160.4zM895.1 713.5 575 553.1l3.7-1.8 320.2 160.4zM901 710.6 580.9 550.2l3.7-1.9 320.1 160.4zM907.3 707.5 586.8 547.2l3.9-2L911 705.6z"
          className="ugl_st137"
        />
        <path
          d="m733.8 666.5-197.5 98.7 197.5 98.7 197.4-98.7z"
          className="ugl_st130"
        />
        <path
          d="m596.7 739.7 188.2 94.4-3.8 2-188.2-94.4zM598.9 738.7 787.1 833l3.7-1.8-188.3-94.4zM604.8 735.7 793 830.1l3.7-1.9-188.2-94.3zM798.8 827.2l-188-94.5 3.7-1.8 188.1 94.4zM804.8 824.2l-188.1-94.4 3.7-1.9 188.1 94.4zM810.7 821.3l-188.1-94.5 3.8-1.9 188.1 94.5zM816.6 818.3l-188-94.5 3.7-1.8 188 94.4zM822.9 815.2l-188.4-94.3 3.9-2 188.2 94.4zM644.4 715.9l188.1 94.4-3.8 1.9-188.2-94.4zM646.5 714.8l188.3 94.4 3.6-1.8L650.2 713zM652.4 711.9l188.2 94.4 3.7-1.9L656.1 710zM846.5 803.4l-188.1-94.5 3.7-1.9 188.1 94.5zM852.4 800.4l-188.1-94.5 3.7-1.8 188.2 94.4zM858.3 797.4l-188-94.4 3.7-1.9 188.1 94.4zM864.2 794.5l-188-94.5 3.7-1.9L868 792.5zM870.5 791.3 682.1 697l3.9-1.9 188.2 94.4zM692.5 691.9l188.2 94.4-3.8 1.9-188.2-94.4zM694.6 690.8l188.3 94.4 3.7-1.9L698.3 689zM700.6 687.8l188.2 94.4 3.7-1.8L704.3 686zM894.6 779.3l-188-94.5 3.7-1.8 188.1 94.4zM900.5 776.3l-188-94.4 3.7-1.9 188.1 94.5zM906.5 773.4l-188.1-94.5 3.7-1.8 188.1 94.4zM912.4 770.4 724.3 676l3.8-1.9 188 94.4zM918.6 767.3 730.3 673l3.9-2 188.2 94.4zM549.1 763.5l188.2 94.4-3.9 1.9-188.2-94.4zM551.2 762.4l188.3 94.4 3.6-1.8-188.2-94.4zM557.1 759.5l188.2 94.4 3.8-1.9-188.3-94.4zM751.2 850.9l-188.1-94.4 3.7-1.9 188.1 94.5zM757.1 848 569 753.5l3.8-1.8 188.1 94.4zM763 845l-188-94.4 3.7-1.9 188.1 94.4zM768.9 842.1l-188-94.5 3.7-1.9 188.1 94.4zM775.2 838.9l-188.4-94.3 3.9-1.9 188.2 94.4z"
          className="ugl_st129"
        />
        <path
          d="m327 672.5-197.4 98.7L327 869.9l197.5-98.7z"
          className="ugl_st130"
        />
        <path
          d="m190 745.7 188.2 94.4-3.8 1.9-188.2-94.4zM192.1 744.6 380.4 839l3.7-1.8-188.3-94.4zM198.1 741.7l188.2 94.4 3.7-1.9-188.2-94.4zM392.1 833.1l-197.4-98.7 3.8-1.9 197.4 98.8zM398 830.2 199.7 731l4.7-1.4 197.4 98.7zM404 827.2l-197.5-98.7 3.8-1.9 197.4 98.7zM409.9 824.3l-197.4-98.8 3.7-1.9 197.4 98.7zM416.1 821.1l-197.4-98.7 3.8-1.8 197.4 98.7zM228.4 717.6l197.4 98.7-3.8 1.9-197.4-98.7zM230.6 716.5 428 815.2l3.7-1.9-197.4-98.7zM236.5 713.5l197.4 98.7 3.7-1.8-197.4-98.7zM439.7 809.3l-197.4-98.7 3.8-1.9 197.4 98.7zM445.7 806.3l-197.5-98.7 3.8-1.8 197.4 98.7zM451.6 803.4l-197.4-98.7 3.7-1.9 197.5 98.7zM457.5 800.4l-197.4-98.7 3.7-1.9 197.4 98.7zM463.8 797.3l-197.5-98.7 3.8-1.9 197.4 98.7zM276.5 693.5 474 792.2l-3.9 1.9-197.4-98.7zM278.8 692.4l197.4 98.7 3.7-1.8-197.5-98.7zM284.6 689.5 482 788.2l3.8-1.9-197.5-98.7zM487.9 785.3l-197.4-98.7 3.7-1.9 197.5 98.7zM493.8 782.3l-197.4-98.7 3.8-1.9 197.4 98.7zM499.7 779.3l-197.4-98.7 3.8-1.9 197.4 98.8zM505.7 776.4l-197.5-98.7 3.7-2 197.5 98.8zM511.9 773.3l-197.4-98.8 3.7-1.8 197.4 98.7zM142.3 769.5l188.2 94.4-3.8 1.9-188.2-94.4zM144.5 768.4l188.2 94.4 3.7-1.9-188.3-94.3zM150.4 765.4l188.2 94.4 3.7-1.8-188.2-94.4zM344.4 856.9l-188-94.5 3.7-1.8L348.2 855zM350.4 853.9l-188.1-94.4 3.7-1.9 188.1 94.5zM356.3 851l-188.1-94.5 3.8-1.8 188.1 94.4zM362.2 848l-188-94.5 3.7-1.8 188 94.4zM368.5 844.9l-188.4-94.3 3.9-2L372.2 843zM-7.4 647l188.2 94.4-3.9 1.9-188.2-94.4zM-5.3 645.9 183 740.3l3.7-1.9-188.3-94.3zM.7 643l188.1 94.4 3.8-1.9L4.4 641.1zM194.7 734.4 6.6 640l3.7-1.9 188.2 94.4z"
          className="ugl_st129"
        />
        <path
          d="M200.6 731.5 12.6 637l3.7-1.8 188.1 94.4zM206.5 728.5 18.5 634l3.7-1.8 188.1 94.4zM212.5 725.5 24.4 631.1l3.7-1.9 188.1 94.4zM218.7 722.4 30.3 628.1l4-1.9 188.2 94.4zM40.2 623.2l188.2 94.4-3.8 1.9-188.2-94.4zM42.3 622.1l188.3 94.4 3.7-1.9L46 620.3zM48.3 619.1l188.2 94.4 3.7-1.8L52 617.3zM242.3 710.6 54.2 616.1l3.8-1.8 188.1 94.4zM248.2 707.6l-188-94.4 3.7-1.9L252 705.8zM254.2 704.7 66.1 610.2l3.7-1.8 188.1 94.4zM260.1 701.7 72 607.2l3.7-1.8 188.1 94.4zM266.3 698.6 78 604.3l3.9-2 188.2 94.4zM88.4 599.1l188.1 94.4-3.8 1.9L84.5 601zM90.5 598l188.3 94.4 3.6-1.8-188.2-94.4zM96.4 595.1l188.2 94.4 3.7-1.9-188.2-94.4zM290.5 686.6l-188.1-94.5 3.7-1.9 188.1 94.5zM296.4 683.6l-188.1-94.5 3.7-1.8 188.2 94.4zM302.3 680.6l-188-94.4 3.7-1.9 188.1 94.4zM308.2 677.7l-188-94.5 3.7-1.9 188 94.4zM314.5 674.5l-188.4-94.3 3.9-1.9 188.2 94.4zM-55.1 670.8l188.2 94.4-3.8 1.9-188.2-94.4zM-53 669.7 135.3 764l3.7-1.8-188.3-94.3zM-47 666.7l188.2 94.4 3.7-1.9-188.2-94.3zM147 758.2l-188-94.5 3.7-1.8 188.1 94.4zM152.9 755.2l-188-94.4 3.7-1.9 188.1 94.4zM158.9 752.3l-188.1-94.5 3.7-1.9 188.1 94.5zM164.8 749.3l-188.1-94.5 3.8-1.8 188 94.4zM171 746.2l-188.3-94.3 3.9-2 188.2 94.4z"
          className="ugl_st129"
        />
        <path
          d="m411.6 634.8 188.2 94.4-3.8 1.9-188.2-94.4zM413.8 633.7 602 728.1l3.7-1.9-188.3-94.3zM419.7 630.8l188.2 94.4 3.7-1.9-188.2-94.4zM613.7 722.2l-188-94.4 3.7-1.9 188.1 94.5zM619.7 719.3l-188.1-94.5 3.7-1.8 188.1 94.4zM625.6 716.3l-188.1-94.5 3.7-1.8 188.2 94.4zM631.5 713.3l-188-94.4 3.7-1.9 188 94.4zM637.8 710.2l-188.4-94.3 3.9-1.9 188.2 94.4zM459.2 611l188.2 94.4-3.8 1.9-188.2-94.4zM461.4 609.9l188.2 94.4 3.7-1.9L465 608.1zM467.3 606.9l188.2 94.4 3.7-1.8L471 605.1zM661.3 698.4l-188-94.5 3.7-1.8 188.1 94.4zM667.3 695.4 479.2 601l3.7-1.9 188.2 94.5zM673.2 692.5l-188-94.5 3.7-1.8L677 690.6zM679.1 689.5l-188-94.5 3.7-1.8 188 94.4zM685.4 686.4 497 592.1l3.9-2 188.2 94.4zM507.4 586.9l188.2 94.4-3.8 1.9-188.2-94.4zM509.5 585.9l188.3 94.3 3.7-1.8L513.2 584zM515.5 582.9l188.2 94.4 3.7-1.9L519.2 581zM709.8 674.3l-188.4-94.4 3.8-1.9 188.4 94.4zM715.8 671.3l-188.4-94.4 3.7-1.8 188.4 94.4zM721.7 668.4 533.3 574l3.7-1.9 188.5 94.4zM727.6 665.4 539.2 571l3.8-1.9 188.3 94.4zM865.6 728.3 545.2 568l3.9-1.9 320.2 160.3zM916.8 702.6 1237.3 863l-3.9 1.9-320.5-160.5zM919.1 701.5l320.4 160.4 3.7-1.8-320.4-160.4zM925 698.6 1245.3 859l3.8-1.9-320.7-160.5zM1251.2 856.1 930.7 695.6l3.7-1.9L1255 854.2zM1257.1 853.1 936.6 692.6l3.8-1.8 320.5 160.4zM1263 850.1 942.6 689.7l3.8-1.8 320.4 160.3zM1269 847.2 948.5 686.7l3.8-1.8 320.4 160.3zM1275.2 844 954.7 683.6l4-1.8 320.2 160.4zM964.2 678.6l320.7 160.6-3.9 1.9-320.8-160.6zM966.6 677.6l320.5 160.5 3.7-1.9-320.5-160.4zM972.2 674.6l320.7 160.6 3.8-1.9L976 672.7zM1298.8 832.2 978.1 671.7l4-1.8 320.5 160.4zM1304.7 829.3 984.2 668.8l3.7-1.9 320.6 160.5zM1310.7 826.3 989.9 665.7l4-1.8 320.5 160.5zM1316.6 823.3 996 662.8l3.8-1.8 320.5 160.4zM1322.8 820.2l-320.4-160.4 3.8-1.8 320.4 160.3zM1012.4 654.6 1333 815.1l-3.8 2-321-160.8zM1014.8 653.6 1335.2 814l3.7-1.8-320.5-160.5zM1020.6 650.6l320.5 160.5 3.7-1.9-320.7-160.5zM1346.9 808.2l-320.6-160.6 3.7-1.9 320.7 160.6zM1352.9 805.2 1032 644.6l4.1-1.8 320.6 160.5zM1358.8 802.3l-320.5-160.5 3.9-1.8 320.4 160.4zM1364.7 799.3l-320.8-160.7 3.4-2 321.1 160.8zM1371 796.2l-320.5-160.5 3.2-2.1 321 160.7zM871.3 725.2l320.5 160.5 3.7-1.9-320.6-160.5zM877 722.2l320.7 160.5 3.7-1.8-320.6-160.5zM1203.5 879.8 883 719.4l3.8-1.9 320.5 160.4zM1209.4 876.9 888.9 716.4l3.8-1.9L1213.2 875zM1215.4 873.9 894.8 713.4l3.9-1.8L1219.1 872zM1221.3 870.9 900.6 710.4l3.6-2L1225 869zM1227.5 867.8 906.9 707.3l4.1-1.7 320.3 160.3z"
          className="ugl_st137"
        />
        <path
          d="M1185.9 888.6 865.5 728.2l3.6-1.9 320.5 160.5zM364 658.6 552.1 753l-3.8 1.9-188.2-94.4zM366.1 657.5l188.3 94.3 3.6-1.8-188.2-94.3zM372 654.5l188.2 94.4 3.7-1.8-188.2-94.4zM566.1 746 378 651.5l3.7-1.8 188.1 94.4zM572 743l-188.1-94.4 3.7-1.9 188.2 94.4zM577.9 740.1l-188-94.5 3.7-1.9 188.1 94.5zM583.8 737.1l-188-94.5 3.7-1.8 188.1 94.4zM590.1 734l-188.4-94.3 3.9-2 188.2 94.4zM524.4 766.8l-188.1-94.4 3.7-1.9 188.2 94.4zM530.3 763.9l-188-94.5 3.7-1.9L534.1 762zM536.2 760.9l-188-94.5 3.7-1.8L540 759zM542.2 757.9l-188.1-94.4 3.7-1.9L545.9 756z"
          className="ugl_st137"
        />
        <path
          d="M321.6 493.8h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M321.6 498.2c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M321.6 493.8v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m333.2 491.3-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4.1 0 0-.1 0-.2z"
          className="ugl_st114"
        />
        <path
          d="m326.5 473.3 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="m329.3 472.4-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8s10.8-1.3 10.8-2.8c.2-.1.2-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M319.2 445.8c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M487.6 570.2h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M487.6 574.7c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M487.6 570.2v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m499.3 567.8-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4v-.2z"
          className="ugl_st114"
        />
        <path
          d="m492.5 549.7 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="M495.4 548.9c0-.1 0-.1 0 0l-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8s10.8-1.3 10.8-2.8c.2-.2.1-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M485.3 522.2c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M409.9 600h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M409.9 604.4c-1 0-2 .1-3 .1s-2 0-2.9-.1V600h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M409.9 600v11c0 .3-.7.6-1.6.8V600h1.6z"
          className="ugl_st132"
        />
        <path
          d="m421.5 597.6-6.8-18.1H399l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4 0 0-.1-.1-.1-.2z"
          className="ugl_st114"
        />
        <path
          d="m414.7 579.5 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="m417.6 578.6-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8 6 0 10.8-1.3 10.8-2.8.2-.1.2-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M407.5 552c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M361.6 632.1h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M361.6 636.5c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M361.6 632.1v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m373.3 629.7-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4v-.2z"
          className="ugl_st114"
        />
        <path
          d="m366.5 611.6 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="m369.4 610.7-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8 6 0 10.8-1.3 10.8-2.8.2-.1.1-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M359.3 584.1c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M390.3 524.8h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M390.3 529.2c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M390.3 524.8v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m401.9 522.4-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4.1 0 0-.1 0-.2z"
          className="ugl_st114"
        />
        <path
          d="m395.1 504.3 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="m398 503.4-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8s10.8-1.3 10.8-2.8c.2-.1.2-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M387.9 476.8c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M350.8 551.9h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M350.8 556.3c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M350.8 551.9v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m362.5 549.5-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4v-.2z"
          className="ugl_st114"
        />
        <path
          d="m355.7 531.4 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="m358.6 530.5-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8s10.8-1.3 10.8-2.8c.1-.1.1-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M348.5 503.9c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M440.4 544.4h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M440.4 548.8c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M440.4 544.4v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m452.1 542-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4.1 0 0-.1 0-.2z"
          className="ugl_st114"
        />
        <path
          d="m445.3 523.9 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="m448.2 523-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8 6 0 10.8-1.3 10.8-2.8.2-.1.1-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M438.1 496.4c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M291.1 551.1h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M291.1 555.5c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M291.1 551.1v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m302.8 548.7-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4v-.2z"
          className="ugl_st114"
        />
        <path
          d="m296 530.6 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="M298.9 529.8c0-.1 0-.1 0 0l-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8 6 0 10.8-1.3 10.8-2.8.1-.2.1-.3.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M288.8 503.1c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M324.6 606.2h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M324.6 610.7c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M324.6 606.2v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m336.2 603.8-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4.1 0 .1-.1 0-.2z"
          className="ugl_st114"
        />
        <path
          d="m329.5 585.7 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="M332.4 584.9c-.1 0-.1 0 0 0l-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8s10.8-1.3 10.8-2.8c.1-.1.1-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M322.2 558.2c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M266.5 608.3h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M266.5 612.7c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M266.5 608.3v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m278.2 605.8-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4v-.2z"
          className="ugl_st114"
        />
        <path
          d="m271.4 587.8 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="m274.3 586.9-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8 6 0 10.8-1.3 10.8-2.8.1-.1.1-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M264.2 560.3c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M229.4 569.9h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M229.4 574.4c-1 0-2 .1-3 .1s-2 0-2.9-.1V570h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M229.4 569.9v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m241.1 567.5-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4v-.2z"
          className="ugl_st114"
        />
        <path
          d="m234.3 549.4 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="m237.2 548.6-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8 6 0 10.8-1.3 10.8-2.8.2-.1.1-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M227.1 521.9c.4.2.7.5.8.9L237 548c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M149.2 525.4h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M149.2 529.8c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M149.2 525.4v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m160.8 523-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4.1-.1.1-.1 0-.2z"
          className="ugl_st114"
        />
        <path
          d="m154.1 504.9 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="M157 504c-.1 0-.1 0 0 0l-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8 6 0 10.8-1.3 10.8-2.8.1-.1.1-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M146.8 477.4c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7.1-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M67.2 457.3h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M67.2 461.8c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M67.2 457.3v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m78.9 454.9-6.8-18.1H56.3l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4v-.2z"
          className="ugl_st114"
        />
        <path
          d="m72.1 436.8 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="m75 436-9.3-25.7c-.5-1.4-2.5-1.4-3 0L53.4 436c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8s10.8-1.3 10.8-2.8c.1-.1.1-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M64.9 409.4c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M260.6 486.2h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M260.6 490.7c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M260.6 486.2v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m272.3 483.8-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4v-.2z"
          className="ugl_st114"
        />
        <path
          d="m265.5 465.7 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="m268.4 464.9-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8 6 0 10.8-1.3 10.8-2.8.1-.1.1-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M258.3 438.2c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M201.3 510.7h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M201.3 515.1c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M201.3 510.7v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m213 508.3-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4v-.2z"
          className="ugl_st114"
        />
        <path
          d="m206.2 490.2 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="m209.1 489.3-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8 6 0 10.8-1.3 10.8-2.8.1-.1.1-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M199 462.7c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M216.2 433.5h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M216.2 438c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M216.2 433.5v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m227.9 431.1-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4v-.2z"
          className="ugl_st114"
        />
        <path
          d="m221.1 413 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="M224 412.2c0-.1 0-.1 0 0l-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8 6 0 10.8-1.3 10.8-2.8.2-.2.1-.3.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M213.9 385.5c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M718.1 232.1h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M718.1 236.5c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M718.1 232.1v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m729.7 229.7-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4.1-.1.1-.2 0-.2z"
          className="ugl_st114"
        />
        <path
          d="m723 211.6 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="m725.9 210.7-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8s10.8-1.3 10.8-2.8c.1-.1.1-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M715.8 184.1c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M661.4 196.5h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M661.4 200.9c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M661.4 196.5v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m673.1 194.1-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4v-.2z"
          className="ugl_st114"
        />
        <path
          d="m666.3 176 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="m669.2 175.1-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8s10.8-1.3 10.8-2.8c.1-.1.1-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M659.1 148.5c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M583.9 166.9h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M583.9 171.4c-1 0-2 .1-3 .1s-2 0-2.9-.1V167h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M583.9 166.9v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m595.5 164.5-6.8-18.1H573l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4 0 0 0-.1-.1-.2z"
          className="ugl_st114"
        />
        <path
          d="m588.8 146.4 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="m591.7 145.6-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8 6 0 10.8-1.3 10.8-2.8.1-.1.1-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M581.6 118.9c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M1074.2 266h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M1074.2 270.5c-1 0-2 .1-3 .1s-2 0-2.9-.1V266h6v4.5z"
          className="ugl_st132"
        />
        <path
          d="M1074.2 266v11c0 .3-.7.6-1.6.8V266h1.6z"
          className="ugl_st132"
        />
        <path
          d="m1085.8 263.6-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4.1 0 .1-.1 0-.2z"
          className="ugl_st114"
        />
        <path
          d="m1079.1 245.5 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="m1082 244.7-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8 6 0 10.8-1.3 10.8-2.8.1-.1.1-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M1071.8 218c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7.1-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M1074.5 169.9h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M1074.5 174.3c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M1074.5 169.9v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m1086.2 167.5-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4v-.2z"
          className="ugl_st114"
        />
        <path
          d="m1079.4 149.4 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="m1082.3 148.5-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8 6 0 10.8-1.3 10.8-2.8.1-.1.1-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M1072.2 121.9c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M1029.5 192.5h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M1029.5 197c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M1029.5 192.5v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m1041.2 190.1-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4v-.2z"
          className="ugl_st114"
        />
        <path
          d="m1034.4 172 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="m1037.3 171.2-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8 6 0 10.8-1.3 10.8-2.8.2-.1.1-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M1027.2 144.6c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.6-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M910.7 328.6h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M910.7 333.1c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M910.7 328.6v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m922.4 326.2-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4v-.2z"
          className="ugl_st114"
        />
        <path
          d="m915.6 308.1 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="m918.5 307.3-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8s10.8-1.3 10.8-2.8c.1-.1.1-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M908.4 280.7c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.6-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M780.1 263.9h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M780.1 268.3c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M780.1 263.9v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m791.7 261.4-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4.1 0 0-.1 0-.2z"
          className="ugl_st114"
        />
        <path
          d="m785 243.3 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="m787.8 242.5-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8s10.8-1.3 10.8-2.8c.2-.1.2-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M777.7 215.9c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="M984.1 225.1h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
          className="ugl_st131"
        />
        <path
          d="M984.1 229.6c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
          className="ugl_st132"
        />
        <path
          d="M984.1 225.1v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
          className="ugl_st132"
        />
        <path
          d="m995.8 222.7-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4v-.2z"
          className="ugl_st114"
        />
        <path
          d="m989 204.6 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
          className="ugl_st133"
        />
        <path
          d="M991.9 203.8c0-.1 0-.1 0 0l-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8s10.8-1.3 10.8-2.8c.1-.2.1-.2.1-.3z"
          className="ugl_st114"
        />
        <path
          d="M981.8 177.1c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
          className="ugl_st133"
        />
        <path
          d="m733.8 449.5-197.5 98.7v3.6l197.5-98.7z"
          className="ugl_st138"
        />
        <path
          d="m733.8 451.6-197.5 98.8v1.4l197.5-98.7z"
          className="ugl_st139"
        />
        <path d="M725.6 448.5v25l3.3-1.9-.1-25z" className="ugl_st138" />
        <path d="M725.6 473.5v-25l1.3-.7v24.9z" className="ugl_st139" />
        <path d="M695.1 463.8v25l3.2-1.9v-25z" className="ugl_st138" />
        <path d="M695.1 488.8v-25l1.2-.7.1 24.9z" className="ugl_st139" />
        <path d="m664.3 479 .1 25 3.2-1.9v-25z" className="ugl_st138" />
        <path d="m664.4 504-.1-25 1.3-.7.1 24.9z" className="ugl_st139" />
        <path d="m633.6 494.4.1 25 3.2-1.9v-25z" className="ugl_st138" />
        <path d="m633.7 519.4-.1-25 1.3-.7v24.9z" className="ugl_st139" />
        <path d="M602.9 509.8v24.9l3.3-1.8-.1-25z" className="ugl_st138" />
        <path d="M602.9 534.7v-24.9l1.3-.8v25z" className="ugl_st139" />
        <path d="M572.2 525.2v24.9l3.3-1.8-.1-25z" className="ugl_st138" />
        <path d="M572.2 550.1v-24.9l1.3-.7v24.9z" className="ugl_st139" />
        <path d="M541.5 540.6v25l3.2-1.9v-25z" className="ugl_st138" />
        <path d="M541.5 565.6v-25l1.2-.7.1 24.9z" className="ugl_st139" />
        <path d="M536.3 557.5v3.6l197.5-98.7v-3.7z" className="ugl_st138" />
        <path d="M536.3 559.7v1.4l197.5-98.7v-1.5z" className="ugl_st139" />
        <path
          d="m931 669.5 5.1 2.6v-12.3l-13.3-6.3zM942.1 640.4c1.6-.7 3.6-.5 5.9.9 4.1 2.4 7.5 7.7 8.5 12.7l-5.3 2.9c-.9-5.1-4.4-10.5-8.6-13-2.2-1.3-4.2-1.6-5.7-1l5.2-2.5z"
          className="ugl_st103"
        />
        <path
          d="M921 638.5v9.3l1.8 1V641l8.2 4.2 2.7 13.5 2.4 1.1-3.7-15.4z"
          className="ugl_st104"
        />
        <path
          d="m932.4 644.4 3.7 15.4v12.3l2.1 1v-13.7l-3.5-14.6 8.2-3.8 7.2 13.1.3.3v-3.5l-6.6-12.4"
          className="ugl_st105"
        />
        <path d="M950.4 644.4v10l3 2.1v-12.1" className="ugl_st104" />
        <ellipse
          cx={951.9}
          cy={644.4}
          className="ugl_st105"
          rx={1.5}
          ry={0.6}
        />
        <path d="M938.2 659.4v11.5l17 6.8v-11.2z" className="ugl_st103" />
        <path
          d="m966.3 677.4 4-2c1.1-.7 1.7-2.1 1.7-4 0-4.1-2.9-9.2-6.5-11.4-1.8-1.1-3.4-1.2-4.6-.5l-2.1 1"
          className="ugl_st106"
        />
        <path
          d="M962.4 667.9V663l-3.5-2.5 2.1-1c1.2-.7 2.8-.6 4.6.5 3.6 2.1 6.5 7.2 6.5 11.4 0 1.9-.6 3.3-1.7 4l-4 2c-1.2.6-2.7.4-4.4-.6-.6-.4-1.3-.9-1.8-1.4l2.3-1.1-.1-6.4z"
          className="ugl_st107"
        />
        <path
          d="M959.5 660.9c.7.1 1.5.4 2.4.9 3.6 2.1 6.5 7.2 6.5 11.4s-2.9 5.8-6.5 3.6c-.6-.4-1.3-.9-1.8-1.4l2.3-1.1V663l-2.9-2.1z"
          className="ugl_st104"
        />
        <path
          d="m938.7 670.6 3.4-1.7c1.2-.7 2.8-.6 4.6.5 3.6 2.1 6.5 7.2 6.5 11.4 0 1.9-.6 3.3-1.7 4l-4 2c-1.2.6-2.7.4-4.4-.6-3.6-2.1-6.5-7.2-6.5-11.4-.1-2.1.7-3.6 2.1-4.2z"
          className="ugl_st107"
        />
        <path
          d="M962.4 673.7c1.7.8 3.1-.2 3.1-2.3 0-2.1-1.3-4.7-3.1-6"
          className="ugl_st108"
        />
        <path
          d="m963.6 665.1-1.8-.9c-.7-.3-.8-1.6-.3-2.8s1.6-1.9 2.3-1.6l1.8.9"
          className="ugl_st104"
        />
        <path
          d="m947.3 686.9 4-2c1.1-.7 1.7-2.1 1.7-4 0-4.1-2.9-9.2-6.5-11.4-1.8-1.1-3.4-1.2-4.6-.5l-3.4 1.7"
          className="ugl_st106"
        />
        <path
          d="M955.2 666.5v11.2l7.2-3.4V663l-7.2 3.5"
          className="ugl_st105"
        />
        <path
          d="m938.2 659.4-3.5-14.6 8.2-3.8 7.2 13.1"
          className="ugl_st108"
        />
        <path d="m955.2 673.8 7.2-3.4V663l-7.2 3.5z" className="ugl_st104" />
        <path
          d="m932.4 644.4-11.4-5.9v-1.2l11.4-5.9 11.4 5.9v1.2z"
          className="ugl_st105"
        />
        <ellipse
          cx={942.9}
          cy={678.8}
          className="ugl_st104"
          rx={5.2}
          ry={9.2}
          transform="rotate(-29.738 942.846 678.828)"
        />
        <ellipse
          cx={942.9}
          cy={678.8}
          className="ugl_st108"
          rx={2.9}
          ry={5.1}
          transform="rotate(-29.738 942.845 678.828)"
        />
        <ellipse
          cx={942.9}
          cy={678.8}
          className="ugl_st107"
          rx={1.3}
          ry={2.3}
          transform="rotate(-29.738 942.845 678.828)"
        />
        <ellipse
          cx={964.6}
          cy={663}
          className="ugl_st108"
          rx={2.4}
          ry={1.4}
          transform="rotate(-65.437 964.557 662.958)"
        />
        <path d="m962.4 663-12.3-8.9-11.9 5.3 17 7.1z" className="ugl_st105" />
        <path
          d="m952.6 670.3-1.8-.9c-.7-.3-.8-1.6-.3-2.8.6-1.2 1.6-1.9 2.3-1.6l1.8.9"
          className="ugl_st104"
        />
        <ellipse
          cx={953.6}
          cy={668.1}
          className="ugl_st108"
          rx={2.4}
          ry={1.4}
          transform="rotate(-65.437 953.613 668.097)"
        />
        <path
          d="M922.8 648v-7l8.2 4.2 2.7 13.5-10.9-5.2z"
          className="ugl_st108"
        />
        <path
          d="m911.8 652.8 4.6-2.3c1.6-.9 3.8-.8 6.2.7 4.8 2.9 8.8 9.8 8.8 15.4 0 2.7-.9 4.5-2.3 5.5l-5.5 2.8c-1.6.8-3.7.6-6-.8-4.8-2.9-8.8-9.8-8.8-15.4.1-3.1 1.2-5.1 3-5.9z"
          className="ugl_st107"
        />
        <path
          d="m923.7 674.9 5.5-2.8c1.4-1 2.3-2.8 2.3-5.5 0-5.6-3.9-12.5-8.8-15.4-2.4-1.5-4.7-1.6-6.2-.7l-4.6 2.3"
          className="ugl_st106"
        />
        <path
          d="M923.8 649.2c4.3 2.2 8 7.4 9.1 12.2l-5.5 2.8c-1-4.8-4.7-10-9-12.3-1.1-.6-2.1-.9-3-1l4.1-2.2 4.3.5z"
          className="ugl_st104"
        />
        <ellipse
          cx={917.7}
          cy={663.9}
          className="ugl_st104"
          rx={7.1}
          ry={12.6}
          transform="rotate(-29.738 917.564 663.903)"
        />
        <ellipse
          cx={917.7}
          cy={663.9}
          className="ugl_st108"
          rx={4}
          ry={7}
          transform="rotate(-29.738 917.564 663.903)"
        />
        <ellipse
          cx={917.7}
          cy={663.9}
          className="ugl_st107"
          rx={1.8}
          ry={3.1}
          transform="rotate(-29.738 917.564 663.903)"
        />
        <path
          d="M919.3 648.2c1.6-.7 3.6-.5 5.9.9 4.1 2.4 7.5 7.7 8.5 12.7l-5.3 2.9c-.9-5.1-4.4-10.5-8.6-13-2.2-1.3-4.2-1.6-5.7-1l5.2-2.5z"
          className="ugl_st103"
        />
        <path
          d="m151.3 565 373.2 186.6v3.6L151.3 568.6z"
          className="ugl_st138"
        />
        <path
          d="m151.3 567.2 373.2 186.6v1.4L151.3 568.6z"
          className="ugl_st139"
        />
        <path d="M166.7 567.9v25l-3.3-1.9.1-24.9z" className="ugl_st138" />
        <path d="M166.7 592.9v-25l-1.3-.7v25z" className="ugl_st139" />
        <path d="m196.2 582.6-.1 25-3.2-1.9.1-25z" className="ugl_st138" />
        <path d="m196.1 607.6.1-25-1.3-.7v24.9z" className="ugl_st139" />
        <path d="m225.7 597.2-.1 25-3.2-1.9v-25z" className="ugl_st138" />
        <path d="m225.6 622.2.1-25-1.3-.7-.1 24.9z" className="ugl_st139" />
        <path d="M255.1 612v25l-3.2-1.9v-24.9z" className="ugl_st138" />
        <path d="M255.1 637v-25l-1.2-.7-.1 25z" className="ugl_st139" />
        <path d="M284.6 626.7v25l-3.3-1.9.1-24.9z" className="ugl_st138" />
        <path d="M284.6 651.7v-25l-1.2-.7-.1 25z" className="ugl_st139" />
        <path d="M314.1 641.6v25l-3.3-1.9.1-25z" className="ugl_st138" />
        <path d="M314.1 666.6v-25l-1.3-.7v24.9z" className="ugl_st139" />
        <path d="M342.9 656v24.9l-3.3-1.9.1-24.9z" className="ugl_st138" />
        <path d="M342.9 680.9V656l-1.3-.8v25z" className="ugl_st139" />
        <path d="M372.4 670.6v25l-3.3-1.9.1-25z" className="ugl_st138" />
        <path d="M372.4 695.6v-25l-1.3-.7v24.9z" className="ugl_st139" />
        <path d="m401.9 685.2-.1 25-3.2-1.9v-25z" className="ugl_st138" />
        <path d="m401.8 710.2.1-25-1.3-.7v24.9z" className="ugl_st139" />
        <path d="m431.4 700.1-.1 24.9-3.2-1.9v-24.9z" className="ugl_st138" />
        <path d="m431.3 725 .1-24.9-1.3-.8-.1 25z" className="ugl_st139" />
        <path d="M460.8 714.8v24.9l-3.2-1.9v-24.9z" className="ugl_st138" />
        <path d="M460.8 739.7v-24.9l-1.2-.8-.1 25z" className="ugl_st139" />
        <path d="M490.3 729.6v25l-3.3-1.9.1-25z" className="ugl_st138" />
        <path d="M490.3 754.6v-25l-1.3-.7v24.9z" className="ugl_st139" />
        <path d="M519.1 744v24.9l-3.2-1.8v-25z" className="ugl_st138" />
        <path d="M519.1 768.9V744l-1.2-.8-.1 25z" className="ugl_st139" />
        <path d="M524.5 760.9v3.4L151.3 577.9v-3.7z" className="ugl_st138" />
        <path d="M524.5 762.2v2.1L151.3 577.9v-1.5z" className="ugl_st139" />
      </g>
      <path
        d="M80.9 379.1h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
        className="ugl_st131"
      />
      <path
        d="M80.9 383.5c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
        className="ugl_st132"
      />
      <path
        d="M80.9 379.1v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
        className="ugl_st132"
      />
      <path
        d="m92.5 376.6-6.8-18.1H70l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4 0 0-.1-.1-.1-.2z"
        className="ugl_st114"
      />
      <path
        d="m85.8 358.5 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
        className="ugl_st133"
      />
      <path
        d="M88.6 357.7 79.4 332c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8 6 0 10.8-1.3 10.8-2.8.1-.1.1-.2 0-.3z"
        className="ugl_st114"
      />
      <path
        d="M78.5 331.1c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
        className="ugl_st133"
      />
      <path
        d="M169.1 443.3h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
        className="ugl_st131"
      />
      <path
        d="M169.1 447.7c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
        className="ugl_st132"
      />
      <path
        d="M169.1 443.3v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
        className="ugl_st132"
      />
      <path
        d="m180.7 440.9-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4.1 0 0-.1 0-.2z"
        className="ugl_st114"
      />
      <path
        d="m173.9 422.8 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
        className="ugl_st133"
      />
      <path
        d="M176.8 422c0-.1 0-.1 0 0l-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8 6 0 10.8-1.3 10.8-2.8.2-.2.2-.3.1-.3z"
        className="ugl_st114"
      />
      <path
        d="M166.7 395.3c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
        className="ugl_st133"
      />
      <path
        d="M121.1 466h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
        className="ugl_st131"
      />
      <path
        d="M121.1 470.4c-1 0-2 .1-3 .1s-2 0-2.9-.1V466h6v4.4z"
        className="ugl_st132"
      />
      <path d="M121.1 466v11c0 .3-.7.6-1.6.8V466h1.6z" className="ugl_st132" />
      <path
        d="m132.7 463.5-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4.1 0 0-.1 0-.2z"
        className="ugl_st114"
      />
      <path
        d="m125.9 445.4 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
        className="ugl_st133"
      />
      <path
        d="m128.8 444.6-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8s10.8-1.3 10.8-2.8c.2-.1.2-.2.1-.3z"
        className="ugl_st114"
      />
      <path
        d="M118.7 418c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
        className="ugl_st133"
      />
      <path
        d="M31 411.3h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
        className="ugl_st131"
      />
      <path
        d="M31 415.7c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
        className="ugl_st132"
      />
      <path d="M31 411.3v11c0 .3-.7.6-1.6.8v-11.8H31z" className="ugl_st132" />
      <path
        d="m42.6 408.9-6.8-18.1H20.1l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4 0 0-.1-.1-.1-.2z"
        className="ugl_st114"
      />
      <path
        d="m35.8 390.8 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
        className="ugl_st133"
      />
      <path
        d="M38.7 390c0-.1 0-.1 0 0l-9.3-25.7c-.5-1.4-2.5-1.4-3 0L17.2 390c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8s10.8-1.3 10.8-2.8c.1-.2.1-.3 0-.3z"
        className="ugl_st114"
      />
      <path
        d="M28.6 363.3c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
        className="ugl_st133"
      />
      <path
        d="M632.4 144.6h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
        className="ugl_st131"
      />
      <path
        d="M632.4 149.1c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
        className="ugl_st132"
      />
      <path
        d="M632.4 144.6v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
        className="ugl_st132"
      />
      <path
        d="m644 142.2-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4.1 0 .1-.1 0-.2z"
        className="ugl_st114"
      />
      <path
        d="m637.3 124.1 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
        className="ugl_st133"
      />
      <path
        d="M640.2 123.3s0-.1 0 0l-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8s10.8-1.3 10.8-2.8c.1-.2.1-.2.1-.3z"
        className="ugl_st114"
      />
      <path
        d="M630.1 96.6c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
        className="ugl_st133"
      />
      <path
        d="M699.8 165h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
        className="ugl_st131"
      />
      <path
        d="M699.8 169.4c-1 0-2 .1-3 .1s-2 0-2.9-.1V165h6v4.4z"
        className="ugl_st132"
      />
      <path d="M699.8 165v11c0 .3-.7.6-1.6.8V165h1.6z" className="ugl_st132" />
      <path
        d="m711.5 162.6-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4v-.2z"
        className="ugl_st114"
      />
      <path
        d="m704.7 144.5 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
        className="ugl_st133"
      />
      <path
        d="M707.6 143.7c0-.1 0-.1 0 0l-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8s10.8-1.3 10.8-2.8c.2-.2.1-.3.1-.3z"
        className="ugl_st114"
      />
      <path
        d="M697.5 117c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
        className="ugl_st133"
      />
      <path
        d="M761.5 197.3h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
        className="ugl_st131"
      />
      <path
        d="M761.5 201.7c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
        className="ugl_st132"
      />
      <path
        d="M761.5 197.3v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
        className="ugl_st132"
      />
      <path
        d="m773.2 194.9-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4v-.2z"
        className="ugl_st114"
      />
      <path
        d="m766.4 176.8 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
        className="ugl_st133"
      />
      <path
        d="m769.3 175.9-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8s10.8-1.3 10.8-2.8c.2-.1.1-.2.1-.3z"
        className="ugl_st114"
      />
      <path
        d="M759.2 149.3c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
        className="ugl_st133"
      />
      <path
        d="M894.2 262.3h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
        className="ugl_st131"
      />
      <path
        d="M894.2 266.8c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
        className="ugl_st132"
      />
      <path
        d="M894.2 262.3v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
        className="ugl_st132"
      />
      <path
        d="m905.8 259.9-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4.1 0 .1-.1 0-.2z"
        className="ugl_st114"
      />
      <path
        d="m899.1 241.8 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
        className="ugl_st133"
      />
      <path
        d="m901.9 241-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8s10.8-1.3 10.8-2.8c.2-.1.2-.2.1-.3z"
        className="ugl_st114"
      />
      <path
        d="M891.8 214.3c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
        className="ugl_st133"
      />
      <path
        d="M991.9 315.5h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
        className="ugl_st131"
      />
      <path
        d="M991.9 319.9c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
        className="ugl_st132"
      />
      <path
        d="M991.9 315.5v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
        className="ugl_st132"
      />
      <path
        d="m1003.5 313.1-6.8-18.1H981l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4 0-.1-.1-.2-.1-.2z"
        className="ugl_st114"
      />
      <path
        d="m996.8 295 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
        className="ugl_st133"
      />
      <path
        d="m999.6 294.1-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8s10.8-1.3 10.8-2.8c.2-.1.2-.2.1-.3z"
        className="ugl_st114"
      />
      <path
        d="M989.5 267.5c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
        className="ugl_st133"
      />
      <path
        d="M944.5 292.3h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
        className="ugl_st131"
      />
      <path
        d="M944.5 296.8c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
        className="ugl_st132"
      />
      <path
        d="M944.5 292.3v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
        className="ugl_st132"
      />
      <path
        d="m956.1 289.9-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4.1 0 .1-.1 0-.2z"
        className="ugl_st114"
      />
      <path
        d="m949.4 271.8 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
        className="ugl_st133"
      />
      <path
        d="m952.3 271-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8 6 0 10.8-1.3 10.8-2.8.1-.1.1-.2.1-.3z"
        className="ugl_st114"
      />
      <path
        d="M942.2 244.3c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
        className="ugl_st133"
      />
      <path
        d="M823.8 234h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
        className="ugl_st131"
      />
      <path
        d="M823.8 238.4c-1 0-2 .1-3 .1s-2 0-2.9-.1V234h6v4.4z"
        className="ugl_st132"
      />
      <path d="M823.8 234v11c0 .3-.7.6-1.6.8V234h1.6z" className="ugl_st132" />
      <path
        d="m835.4 231.6-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4.1 0 .1-.1 0-.2z"
        className="ugl_st114"
      />
      <path
        d="m828.7 213.5 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
        className="ugl_st133"
      />
      <path
        d="m831.6 212.6-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8s10.8-1.3 10.8-2.8c.1-.1.1-.2.1-.3z"
        className="ugl_st114"
      />
      <path
        d="M821.5 186c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
        className="ugl_st133"
      />
      <path
        d="M850.6 294h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
        className="ugl_st131"
      />
      <path
        d="M850.6 298.4c-1 0-2 .1-3 .1s-2 0-2.9-.1V294h6v4.4z"
        className="ugl_st132"
      />
      <path d="M850.6 294v11c0 .3-.7.6-1.6.8V294h1.6z" className="ugl_st132" />
      <path
        d="m862.2 291.6-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4.1 0 0-.1 0-.2z"
        className="ugl_st114"
      />
      <path
        d="m855.4 273.5 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
        className="ugl_st133"
      />
      <path
        d="m858.3 272.6-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8 6 0 10.8-1.3 10.8-2.8.2-.1.2-.2.1-.3z"
        className="ugl_st114"
      />
      <path
        d="M848.2 246c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
        className="ugl_st133"
      />
      <path
        d="M646.6 629.5c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM676.3 645.4c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM611 636.9c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6z"
        className="ugl_st135"
      />
      <path
        d="M643.6 609c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.5.1 1-.2 1.1-.6zM640.4 652.7c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.2 1.1-.6zM687.9 663.5c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM684.7 623.7c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.5 0 1-.3 1.1-.6z"
        className="ugl_st145"
      />
      <path
        d="M611.5 611.6c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.2-.5 1.3-.8zM685.7 582.4c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM677.9 601.4c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.2-.4 1.3-.8zM744.2 634.5c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.2-.5 1.3-.8zM714.1 620.1c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.8-.1 1.3-.4 1.3-.8zM711.5 647.1c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.3-.4 1.3-.8zM664.9 670.1c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.3-.4 1.3-.8zM714.4 575.8c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.3-.4 1.3-.8z"
        className="ugl_st135"
      />
      <path
        d="M713.5 597.5c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.3-.4 1.3-.8zM773.1 571.2c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.3-.4 1.3-.8zM763.3 611.3c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.2-.4 1.3-.8z"
        className="ugl_st145"
      />
      <path
        d="M698.9 557.8c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6z"
        className="ugl_st135"
      />
      <path
        d="M727.1 555.9c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.2 1.1-.6z"
        className="ugl_st145"
      />
      <path
        d="M745.9 573.5c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM822.8 587.8c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM744.3 593.7c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM786.2 594.1c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM790.6 613.1c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM734.3 535.1c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.5 0 1-.3 1.1-.6zM760.6 526.3c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.2 1.1-.6zM759.9 509.9c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM754.5 548.3c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM780.9 555.2c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6.1 1.1-.2 1.1-.6zM835.2 562c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM809.6 545.3c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM844.8 545.4c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM797.6 520.9c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6z"
        className="ugl_st135"
      />
      <path
        d="M784.7 538.1c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM823.5 534.4c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6.1 1.1-.2 1.1-.6zM805.9 566.7c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM865.9 566.3c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6z"
        className="ugl_st145"
      />
      <path
        d="M597.5 595.2c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1-.4 1.1-.7z"
        className="ugl_st135"
      />
      <path
        d="M594.5 576.2c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.2 1-.4 1.1-.7zM578.2 616.5c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.2 1.1-.4 1.1-.7zM526.5 592.9c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.2 1.1-.4 1.1-.7z"
        className="ugl_st145"
      />
      <path
        d="M562.4 578.6c0-.4-.5-.7-1.3-.7h-.1c-.1-.2-.5-.4-1-.4s-.9.2-1.1.4c-.8 0-1.4.4-1.5.7 0 .3.4.6 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.7v-.2c.7-.1 1.3-.4 1.3-.7zM570.7 569.7c0-.4-.5-.7-1.3-.7h-.1c-.1-.2-.5-.4-1-.4s-.9.2-1.1.4c-.8 0-1.4.4-1.5.7 0 .3.4.6 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.7v-.2c.7 0 1.2-.3 1.3-.7zM636.7 551.2c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.5-.1 1-.4 1.1-.7zM628.8 569c0-.4-.5-.7-1.3-.7h-.1c-.1-.2-.5-.4-1-.4s-.9.2-1.1.4c-.8 0-1.4.4-1.5.7 0 .3.4.6 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.7v-.2c.7 0 1.3-.3 1.3-.7zM606.5 555.3c0-.4-.5-.7-1.3-.7h-.1c-.1-.2-.5-.4-1-.4s-.9.2-1.1.4c-.8 0-1.4.4-1.5.7 0 .3.4.6 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.7v-.2c.8-.1 1.3-.3 1.3-.7zM572.8 597.1c0-.4-.5-.7-1.3-.7h-.1c-.1-.2-.5-.4-1-.4s-.9.2-1.1.4c-.8 0-1.4.4-1.5.7 0 .3.4.6 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.7v-.2c.7-.1 1.3-.4 1.3-.7zM538.8 605.3c0-.4-.5-.7-1.3-.7h-.1c-.1-.2-.5-.4-1-.4s-.9.2-1.1.4c-.8 0-1.4.4-1.5.7 0 .3.4.6 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.7v-.2c.7 0 1.2-.3 1.3-.7zM665.4 545c0-.4-.5-.7-1.3-.7h-.1c-.1-.2-.5-.4-1-.4s-.9.2-1.1.4c-.8 0-1.4.4-1.5.7 0 .3.4.6 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.7v-.2c.7 0 1.3-.3 1.3-.7z"
        className="ugl_st135"
      />
      <path
        d="M664.5 565.3c0-.4-.5-.7-1.3-.7h-.1c-.1-.2-.5-.4-1-.4s-.9.2-1.1.4c-.8 0-1.4.4-1.5.7 0 .3.4.6 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.7v-.2c.7 0 1.2-.3 1.3-.7z"
        className="ugl_st145"
      />
      <path
        d="M629.4 590c0-.4-.5-.7-1.3-.7h-.1c-.1-.2-.5-.4-1-.4s-.9.2-1.1.4c-.8 0-1.4.4-1.5.7 0 .3.4.6 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.7v-.2c.7-.1 1.3-.4 1.3-.7zM660.1 586.4c0-.4-.5-.7-1.3-.7h-.1c-.1-.2-.5-.4-1-.4s-.9.2-1.1.4c-.8 0-1.4.4-1.5.7 0 .3.4.6 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.7v-.2c.7 0 1.3-.3 1.3-.7z"
        className="ugl_st135"
      />
      <path
        d="M649.9 528.3c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.2 1-.4 1.1-.7z"
        className="ugl_st145"
      />
      <path
        d="M678.1 526.5c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.2 1.1-.4 1.1-.7zM696.9 542.8c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1.1-.4 1.1-.7zM685.3 507c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1.1-.4 1.1-.7zM711.7 498.8c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1.1-.4 1.1-.7zM735.3 493.1c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1.1-.4 1.1-.7zM705.5 519.3c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1.1-.4 1.1-.7zM731.9 525.7c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1.1-.4 1.1-.7z"
        className="ugl_st135"
      />
      <path
        d="M735.7 509.7c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1.1-.4 1.1-.7zM551.1 623.2c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM545.4 694.5c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.8-.1 1.3-.4 1.3-.8zM499.4 679.2c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6.1 1.1-.2 1.1-.6z"
        className="ugl_st145"
      />
      <path
        d="M518.2 696.8c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6.1 1.1-.2 1.1-.6zM595.2 711.1c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.5 0 1-.3 1.1-.6zM558.6 717.4c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.2 1.1-.6zM506.6 658.4c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM533 649.7c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.5 0 1-.3 1.1-.6zM532.2 633.2c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.2 1.1-.6zM526.8 671.6c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.2 1.1-.6zM553.2 678.6c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM607.5 685.3c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM582 668.6c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.5 0 1-.3 1.1-.6zM617.1 668.7c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.2 1.1-.6zM570 644.2c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.5 0 1-.3 1.1-.6z"
        className="ugl_st135"
      />
      <path
        d="M557 661.4c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM595.8 657.8c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM578.2 690c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM638.2 689.6c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6z"
        className="ugl_st145"
      />
      <path
        d="M450.4 649.8c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1.1-.4 1.1-.7zM469.2 666.2c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.2 1.1-.4 1.1-.7zM457.6 630.3c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1.1-.4 1.1-.7zM484 622.1c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1.1-.4 1.1-.7zM507.7 616.5c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.5-.2 1-.4 1.1-.7zM477.8 642.6c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1.1-.4 1.1-.7zM504.3 649.1c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.2 1-.4 1.1-.7z"
        className="ugl_st135"
      />
      <path
        d="M508.1 633c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.5-.1 1-.4 1.1-.7z"
        className="ugl_st145"
      />
      <path
        d="M468.4 339.3c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM498.2 355.2c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.2 1.1-.6zM432.8 346.8c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6z"
        className="ugl_st135"
      />
      <path
        d="M465.4 318.9c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM462.3 362.6c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.5 0 1-.3 1.1-.6zM509.9 372.3c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM506.5 333.5c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.2 1.1-.6z"
        className="ugl_st145"
      />
      <path
        d="M433.3 321.4c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.3-.4 1.3-.8zM507.5 292.2c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM499.7 311.3c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.3-.4 1.3-.8zM566 344.3c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.3-.4 1.3-.8zM536 330c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.2-.5 1.3-.8zM535.4 348c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.2-.4 1.3-.8zM475.5 374.6c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.2 1.2-.5 1.3-.8zM536.3 285.7c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.2 1.2-.5 1.3-.8z"
        className="ugl_st135"
      />
      <path
        d="M535.4 307.4c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.2-.4 1.3-.8zM595 281c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.2-.4 1.3-.8zM585.1 321.1c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.3-.4 1.3-.8z"
        className="ugl_st145"
      />
      <path
        d="M520.7 267.7c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6z"
        className="ugl_st135"
      />
      <path
        d="M548.9 265.8c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6z"
        className="ugl_st145"
      />
      <path
        d="M567.8 283.4c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.5 0 1-.3 1.1-.6zM645.4 295c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM566.1 303.5c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.2 1.1-.6zM608.1 304c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM612.4 320.2c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM556.1 244.9c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6.1 1.1-.2 1.1-.6zM582.5 236.2c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM581.7 219.8c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM576.3 258.2c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM602.8 265.1c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.5 0 1-.3 1.1-.6zM657 271.8c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM631.5 255.1c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM666.6 255.3c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM619.5 230.7c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6z"
        className="ugl_st135"
      />
      <path
        d="M606.5 247.9c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM645.4 244.3c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM627.7 276.5c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM689.5 270.5c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.2 1.1-.6z"
        className="ugl_st145"
      />
      <path
        d="M419.3 305.1c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.2 1.1-.4 1.1-.7z"
        className="ugl_st135"
      />
      <path
        d="M416.3 286c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1.1-.4 1.1-.7zM400.1 326.3c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1-.4 1.1-.7zM348.3 302.7c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1.1-.4 1.1-.7z"
        className="ugl_st145"
      />
      <path
        d="M384.2 288.4c0-.4-.5-.7-1.3-.7h-.1c-.1-.2-.5-.4-1-.4s-.9.2-1.1.4c-.8 0-1.4.4-1.5.7 0 .3.4.6 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.7v-.2c.8 0 1.3-.3 1.3-.7zM392.5 279.6c0-.4-.5-.7-1.3-.7h-.1c-.1-.2-.5-.4-1-.4s-.9.2-1.1.4c-.8 0-1.4.4-1.5.7 0 .3.4.6 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.7v-.2c.7-.1 1.3-.4 1.3-.7zM458.5 261c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1.1-.4 1.1-.7zM450.7 278.9c0-.4-.5-.7-1.3-.7h-.1c-.1-.2-.5-.4-1-.4s-.9.2-1.1.4c-.8 0-1.4.4-1.5.7 0 .3.4.6 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.7v-.2c.7-.1 1.2-.4 1.3-.7zM428.4 265.2c0-.4-.5-.7-1.3-.7h-.1c-.1-.2-.5-.4-1-.4s-.9.2-1.1.4c-.8 0-1.4.4-1.5.7 0 .3.4.6 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.7v-.2c.7-.1 1.2-.4 1.3-.7zM394.6 306.9c0-.4-.5-.7-1.3-.7h-.1c-.1-.2-.5-.4-1-.4s-.9.2-1.1.4c-.8 0-1.4.4-1.5.7 0 .3.4.6 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.7v-.2c.8 0 1.3-.3 1.3-.7zM360.6 315.2c0-.4-.5-.7-1.3-.7h-.1c-.1-.2-.5-.4-1-.4s-.9.2-1.1.4c-.8 0-1.4.4-1.5.7 0 .3.4.6 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.7v-.2c.7-.1 1.3-.4 1.3-.7zM487.2 254.9c0-.4-.5-.7-1.3-.7h-.1c-.1-.2-.5-.4-1-.4s-.9.2-1.1.4c-.8 0-1.4.4-1.5.7 0 .3.4.6 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.7v-.2c.8-.1 1.3-.4 1.3-.7z"
        className="ugl_st135"
      />
      <path
        d="M486.3 275.2c0-.4-.5-.7-1.3-.7h-.1c-.1-.2-.5-.4-1-.4s-.9.2-1.1.4c-.8 0-1.4.4-1.5.7 0 .3.4.6 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.7v-.2c.7-.1 1.3-.4 1.3-.7z"
        className="ugl_st145"
      />
      <path
        d="M451.2 299.8c0-.4-.5-.7-1.3-.7h-.1c-.1-.2-.5-.4-1-.4s-.9.2-1.1.4c-.8 0-1.4.4-1.5.7 0 .3.4.6 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.7v-.2c.8 0 1.3-.3 1.3-.7zM482 296.3c0-.4-.5-.7-1.3-.7h-.1c-.1-.2-.5-.4-1-.4s-.9.2-1.1.4c-.8 0-1.4.4-1.5.7 0 .3.4.6 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.7v-.2c.7-.1 1.2-.4 1.3-.7z"
        className="ugl_st135"
      />
      <path
        d="M471.7 238.1c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1.1-.4 1.1-.7z"
        className="ugl_st145"
      />
      <path
        d="M500 236.3c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.5-.1 1-.4 1.1-.7zM518.7 252.7c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1.1-.4 1.1-.7zM507.1 216.9c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.2 1.1-.4 1.1-.7zM533.5 208.6c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1.1-.4 1.1-.7zM557.2 203c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1-.4 1.1-.7zM527.4 229.2c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.5-.2 1-.4 1.1-.7zM553.8 235.6c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.2 1-.4 1.1-.7z"
        className="ugl_st135"
      />
      <path
        d="M557.6 219.5c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1-.3 1.1-.7zM372.9 333c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM367.3 404.4c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.2 1.2-.5 1.3-.8zM321.3 389.1c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6z"
        className="ugl_st145"
      />
      <path
        d="M340.1 406.7c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM380.4 427.3c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM328.4 368.3c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM354.8 359.5c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM354 343.1c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM348.7 381.5c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.5 0 1-.3 1.1-.6zM375.1 388.4c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM429.4 395.1c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.2 1.1-.6zM403.8 378.4c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6.1 1.1-.2 1.1-.6zM438.9 378.6c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM391.8 354c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.2 1.1-.6z"
        className="ugl_st135"
      />
      <path
        d="M378.8 371.2c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6.1 1.1-.2 1.1-.6zM417.7 367.6c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.2 1.1-.6zM400 399.8c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.2 1.1-.6z"
        className="ugl_st145"
      />
      <path
        d="M272.3 359.6c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1-.4 1.1-.7zM291.1 376c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1-.4 1.1-.7zM279.5 340.2c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1-.4 1.1-.7zM305.9 332c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.2 1-.4 1.1-.7zM329.5 326.3c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1.1-.4 1.1-.7zM299.7 352.5c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1-.4 1.1-.7zM326.1 358.9c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.1 1.1-.4 1.1-.7z"
        className="ugl_st135"
      />
      <path
        d="M329.9 342.9c0-.3-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.3-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.6s.4.5.9.6c0 .1-.1.1-.1.2 0 .3.5.6 1.2.6s1.3-.3 1.3-.6v-.2c.6-.2 1.1-.4 1.1-.7z"
        className="ugl_st145"
      />
      <path
        d="M267.9 280.4c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM297.6 296.3c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM232.3 287.8c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6.1 1-.2 1.1-.6z"
        className="ugl_st135"
      />
      <path
        d="M264.8 260c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM261.7 303.7c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM309.2 314.4c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM306 274.6c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.5 0 1-.3 1.1-.6z"
        className="ugl_st145"
      />
      <path
        d="M307 233.3c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM299.2 252.4c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.2-.5 1.3-.8zM365.5 285.4c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.2-.4 1.3-.8zM342.5 267.6c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.8-.1 1.3-.4 1.3-.8zM332.8 298c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.3-.4 1.3-.8zM286.2 321c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.3-.4 1.3-.8zM335.7 226.7c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.3-.4 1.3-.8z"
        className="ugl_st135"
      />
      <path
        d="M334.8 248.5c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.3-.5 1.3-.8zM394.4 222.1c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.3-.4 1.3-.8zM384.6 262.2c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.2-.4 1.3-.8z"
        className="ugl_st145"
      />
      <path
        d="M367.2 224.5c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM444.1 238.7c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM365.6 244.6c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM407.5 245c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6.1 1.1-.2 1.1-.6zM411.9 264c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM375.8 199.2c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6.1 1-.2 1.1-.6zM402.2 206.2c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM456.5 212.9c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM430.9 196.2c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM466.1 196.3c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6.1 1-.2 1.1-.6z"
        className="ugl_st135"
      />
      <path
        d="M406 189c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM444.8 185.4c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM427.2 217.6c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM487.2 217.2c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM166.7 345.4c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.8-.1 1.3-.4 1.3-.8zM120.9 336.2c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6z"
        className="ugl_st145"
      />
      <path
        d="M139.5 347.8c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM209.9 371.5c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.2 1.1-.6zM179.9 368.4c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.5 0 1-.3 1.1-.6zM148.1 322.6c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM174.5 329.5c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM228.8 336.2c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM203.3 319.5c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.5 0 1-.2 1.1-.6zM238.4 319.7c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM191.2 295.1c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6z"
        className="ugl_st135"
      />
      <path
        d="M178.3 312.3c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.2 1.1-.6zM217.1 308.7c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM199.5 340.9c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM232.3 352.8c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM231.3 389.1c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.2-.5 1.3-.8z"
        className="ugl_st145"
      />
      <path
        d="M287.8 402.8c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM251.2 409.1c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM245.9 370.2c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6.1 1.1-.2 1.1-.6z"
        className="ugl_st135"
      />
      <path
        d="M270.9 381.7c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM297.9 427.3c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.8-.2 1.3-.5 1.3-.8z"
        className="ugl_st145"
      />
      <path
        d="M357 435.9c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.2 1.1-.6zM316 442.3c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM313.9 409.8c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.5 0 1-.2 1.1-.6z"
        className="ugl_st135"
      />
      <path
        d="M338.1 425.8c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6.1 1.1-.2 1.1-.6zM258 334.9c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.5.1 1-.2 1.1-.6z"
        className="ugl_st145"
      />
      <path
        d="M579.9 106.9c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6z"
        className="ugl_st135"
      />
      <path
        d="M544.3 120.7c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM594.7 131.3c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6z"
        className="ugl_st145"
      />
      <path
        d="M615.5 115c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.2-.4 1.3-.8zM568 132.4c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.8-.2 1.3-.5 1.3-.8z"
        className="ugl_st135"
      />
      <path
        d="M455.5 156.9c0-.4-.5-.7-1.3-.7h-.1c-.1-.3-.5-.4-1-.4s-.9.2-1.1.5c-.8 0-1.4.4-1.5.8 0 .4.4.7 1 .7 0 .1-.1.1-.1.2 0 .4.5.7 1.3.7s1.4-.4 1.5-.8v-.2c.7-.1 1.3-.4 1.3-.8zM527.2 191.6c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6z"
        className="ugl_st145"
      />
      <path
        d="M505.2 173.5c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM468.6 179.8c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.2 1.1-.6zM494.2 195.1c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM517.6 147.7c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6zM527.2 131.1c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6z"
        className="ugl_st135"
      />
      <path
        d="M488.3 152.4c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1-.3 1.1-.6zM548.3 152c0-.4-.5-.6-1.2-.6h-.1c-.1-.2-.4-.4-.9-.4-.4 0-.8.2-.9.4-.7 0-1.3.3-1.3.7 0 .3.4.6.9.6 0 .1-.1.1-.1.2 0 .4.5.6 1.2.6s1.3-.3 1.3-.7v-.2c.6 0 1.1-.3 1.1-.6z"
        className="ugl_st145"
      />
      <path
        d="m587.4 638.8 5.1 2.6v-12.3l-13.3-6.2zM598.5 609.7c1.6-.7 3.6-.5 5.9.9 4.1 2.4 7.5 7.7 8.5 12.7l-5.3 2.9c-.9-5.1-4.4-10.5-8.6-13-2.2-1.3-4.2-1.6-5.7-1l5.2-2.5z"
        className="ugl_st103"
      />
      <path
        d="M577.4 607.8v9.4l1.8.9v-7.7l8.2 4.2 2.7 13.4 2.4 1.1-3.7-15.4z"
        className="ugl_st104"
      />
      <path
        d="m588.8 613.7 3.7 15.4v12.3l2.1 1v-13.7l-3.5-14.6 8.2-3.7 7.1 13 .4.3v-3.5l-6.6-12.4"
        className="ugl_st105"
      />
      <path d="M606.8 613.7v10l3 2.1v-12.1" className="ugl_st104" />
      <ellipse cx={608.3} cy={613.7} className="ugl_st105" rx={1.5} ry={0.6} />
      <path d="M594.6 628.7v11.5l17 6.9v-11.3z" className="ugl_st103" />
      <path
        d="m622.7 646.7 4-2c1.1-.7 1.7-2.1 1.7-4 0-4.1-2.9-9.2-6.5-11.4-1.8-1.1-3.4-1.2-4.6-.5l-2.1 1"
        className="ugl_st106"
      />
      <path
        d="M618.8 637.3v-4.9l-3.5-2.5 2.1-1c1.2-.7 2.8-.6 4.6.5 3.6 2.1 6.5 7.2 6.5 11.4 0 1.9-.6 3.3-1.7 4l-4 2c-1.2.6-2.7.4-4.4-.6-.6-.4-1.3-.9-1.8-1.4l2.3-1.1-.1-6.4z"
        className="ugl_st107"
      />
      <path
        d="M615.9 630.2c.7.1 1.5.4 2.4.9 3.6 2.1 6.5 7.2 6.5 11.4s-2.9 5.8-6.5 3.6c-.6-.4-1.3-.9-1.8-1.4l2.3-1.1v-11.3l-2.9-2.1z"
        className="ugl_st104"
      />
      <path
        d="m595 640 3.4-1.7c1.2-.7 2.8-.6 4.6.5 3.6 2.1 6.5 7.2 6.5 11.4 0 1.9-.6 3.3-1.7 4l-4 2c-1.2.6-2.7.4-4.4-.6-3.6-2.1-6.5-7.2-6.5-11.4 0-2.1.8-3.6 2.1-4.2z"
        className="ugl_st107"
      />
      <path
        d="M618.8 643.1c1.7.8 3.1-.2 3.1-2.3 0-2.1-1.3-4.7-3.1-6"
        className="ugl_st108"
      />
      <path
        d="m620 634.5-1.8-.9c-.7-.3-.8-1.6-.3-2.8s1.6-1.9 2.3-1.6l1.8.9"
        className="ugl_st104"
      />
      <path
        d="m603.7 656.2 4-2c1.1-.7 1.7-2.1 1.7-4 0-4.1-2.9-9.2-6.5-11.4-1.8-1.1-3.4-1.2-4.6-.5L595 640"
        className="ugl_st106"
      />
      <path
        d="M611.6 635.8v11.3l7.2-3.5v-11.3l-7.2 3.5"
        className="ugl_st105"
      />
      <path d="m594.6 628.7-3.5-14.6 8.2-3.7 7.1 13" className="ugl_st108" />
      <path d="m611.6 643.2 7.2-3.5v-7.4l-7.2 3.5z" className="ugl_st104" />
      <path
        d="m588.8 613.7-11.4-5.9v-1.1l11.4-6 11.4 6v1.1z"
        className="ugl_st105"
      />
      <ellipse
        cx={599.3}
        cy={648.1}
        className="ugl_st104"
        rx={5.2}
        ry={9.2}
        transform="rotate(-29.738 599.26 648.14)"
      />
      <ellipse
        cx={599.3}
        cy={648.1}
        className="ugl_st108"
        rx={2.9}
        ry={5.1}
        transform="rotate(-29.738 599.26 648.14)"
      />
      <ellipse
        cx={599.3}
        cy={648.1}
        className="ugl_st107"
        rx={1.3}
        ry={2.3}
        transform="rotate(-29.738 599.26 648.14)"
      />
      <ellipse
        cx={621}
        cy={632.3}
        className="ugl_st108"
        rx={2.4}
        ry={1.4}
        transform="rotate(-65.437 620.956 632.284)"
      />
      <path d="m618.8 632.3-12.4-8.9-11.8 5.3 17 7.1z" className="ugl_st105" />
      <path
        d="m609 639.6-1.8-.9c-.7-.3-.8-1.6-.3-2.8.6-1.2 1.6-1.9 2.3-1.6l1.8.9"
        className="ugl_st104"
      />
      <ellipse
        cx={610}
        cy={637.4}
        className="ugl_st108"
        rx={2.4}
        ry={1.4}
        transform="rotate(-65.437 610.012 637.423)"
      />
      <path
        d="M579.2 617.4v-7l8.2 4.2 2.7 13.4-10.9-5.1z"
        className="ugl_st108"
      />
      <path
        d="m568.2 622.1 4.6-2.3c1.6-.9 3.8-.8 6.2.7 4.8 2.9 8.8 9.8 8.8 15.4 0 2.7-.9 4.5-2.3 5.5l-5.5 2.8c-1.6.8-3.7.6-6-.8-4.8-2.9-8.8-9.8-8.8-15.4.1-3.1 1.2-5.1 3-5.9z"
        className="ugl_st107"
      />
      <path
        d="m580.1 644.2 5.5-2.8c1.4-1 2.3-2.8 2.3-5.5 0-5.6-3.9-12.5-8.8-15.4-2.4-1.5-4.7-1.6-6.2-.7l-4.6 2.3"
        className="ugl_st106"
      />
      <path
        d="M580.2 618.6c4.3 2.2 8 7.4 9.1 12.2l-5.5 2.8c-1-4.8-4.7-10-9-12.3-1.1-.6-2.1-.9-3-1l4.1-2.2 4.3.5z"
        className="ugl_st104"
      />
      <ellipse
        cx={574.1}
        cy={633.2}
        className="ugl_st104"
        rx={7.1}
        ry={12.6}
        transform="rotate(-29.738 573.98 633.214)"
      />
      <ellipse
        cx={574.1}
        cy={633.2}
        className="ugl_st108"
        rx={4}
        ry={7}
        transform="rotate(-29.738 573.98 633.214)"
      />
      <ellipse
        cx={574.1}
        cy={633.2}
        className="ugl_st107"
        rx={1.8}
        ry={3.1}
        transform="rotate(-29.738 573.98 633.214)"
      />
      <path
        d="M575.7 617.6c1.6-.7 3.6-.5 5.9.9 4.1 2.4 7.5 7.7 8.5 12.7l-5.3 2.9c-.9-5.1-4.4-10.5-8.6-13-2.2-1.3-4.2-1.6-5.7-1l5.2-2.5zM724.7 347.4l-5.2 2.5v-12.3l13.3-6.2zM713.6 318.2c-1.6-.7-3.6-.5-5.9.9-4.1 2.4-7.5 7.7-8.5 12.7l5.3 2.9c.9-5.1 4.4-10.5 8.6-13 2.2-1.3 4.2-1.6 5.7-1l-5.2-2.5z"
        className="ugl_st103"
      />
      <path
        d="M734.6 316.3v9.4l-1.8.9v-7.7l-8.1 4.2-2.8 13.4-2.4 1.1 3.7-15.4z"
        className="ugl_st104"
      />
      <path
        d="m723.2 322.2-3.7 15.4v12.3l-2.1 1v-13.7l3.5-14.6-8.2-3.7-7.1 13.1-.4.2v-3.5l6.7-12.4"
        className="ugl_st105"
      />
      <path d="M705.2 322.2v10l-2.9 2.2v-12.2" className="ugl_st104" />
      <ellipse cx={703.7} cy={322.2} className="ugl_st105" rx={1.5} ry={0.6} />
      <path d="M717.4 337.2v11.5l-17 6.9v-11.3z" className="ugl_st103" />
      <path
        d="m689.3 355.3-4-2c-1.1-.7-1.7-2.1-1.7-4 0-4.1 2.9-9.2 6.5-11.4 1.8-1.1 3.4-1.2 4.6-.5l2.1 1"
        className="ugl_st106"
      />
      <path
        d="M693.2 345.8v-4.9l3.5-2.5-2.1-1c-1.2-.7-2.8-.6-4.6.5-3.6 2.1-6.5 7.2-6.5 11.4 0 1.9.6 3.3 1.7 4l4 2c1.2.6 2.7.4 4.4-.6.6-.4 1.3-.9 1.8-1.4l-2.3-1.1.1-6.4z"
        className="ugl_st107"
      />
      <path
        d="M696.1 338.8c-.7.1-1.5.4-2.4.9-3.6 2.1-6.5 7.2-6.5 11.4 0 4.1 2.9 5.8 6.5 3.6.6-.4 1.3-.9 1.8-1.4l-2.3-1.1v-11.3l2.9-2.1z"
        className="ugl_st104"
      />
      <path
        d="m717 348.5-3.4-1.7c-1.2-.7-2.8-.6-4.6.5-3.6 2.1-6.5 7.2-6.5 11.4 0 1.9.6 3.3 1.7 4l4 2c1.2.6 2.7.4 4.4-.6 3.6-2.1 6.5-7.2 6.5-11.4.1-2.1-.8-3.6-2.1-4.2z"
        className="ugl_st107"
      />
      <path
        d="M693.2 351.6c-1.7.8-3.1-.2-3.1-2.3 0-2.1 1.3-4.6 3.1-6"
        className="ugl_st108"
      />
      <path
        d="m692.1 343 1.8-.9c.7-.3.8-1.6.3-2.8-.6-1.2-1.6-1.9-2.3-1.6l-1.8.9"
        className="ugl_st104"
      />
      <path
        d="m708.3 364.8-4-2c-1.1-.7-1.7-2.1-1.7-4 0-4.1 2.9-9.2 6.5-11.4 1.8-1.1 3.4-1.2 4.6-.5l3.4 1.7"
        className="ugl_st106"
      />
      <path
        d="M700.4 344.3v11.3l-7.2-3.5v-11.3l7.2 3.5"
        className="ugl_st105"
      />
      <path d="m717.4 337.2 3.5-14.6-8.2-3.7-7.1 13.1" className="ugl_st108" />
      <path d="m700.4 351.7-7.2-3.5v-7.4l7.2 3.5z" className="ugl_st104" />
      <path
        d="m723.2 322.2 11.4-5.9v-1.1l-11.4-6-11.3 6v1.1z"
        className="ugl_st105"
      />
      <ellipse
        cx={712.7}
        cy={356.7}
        className="ugl_st104"
        rx={9.2}
        ry={5.2}
        transform="rotate(-60.264 712.744 356.678)"
      />
      <ellipse
        cx={712.7}
        cy={356.7}
        className="ugl_st108"
        rx={5.1}
        ry={2.9}
        transform="rotate(-60.264 712.744 356.678)"
      />
      <ellipse
        cx={712.7}
        cy={356.7}
        className="ugl_st107"
        rx={2.3}
        ry={1.3}
        transform="rotate(-60.264 712.744 356.678)"
      />
      <ellipse
        cx={691.1}
        cy={340.8}
        className="ugl_st108"
        rx={1.4}
        ry={2.4}
        transform="rotate(-24.564 691.102 340.817)"
      />
      <path d="m693.2 340.8 12.4-8.8 11.8 5.2-17 7.1z" className="ugl_st105" />
      <path
        d="m703 348.1 1.8-.9c.7-.3.8-1.6.3-2.8-.6-1.2-1.6-1.9-2.3-1.6l-1.8.9"
        className="ugl_st104"
      />
      <ellipse
        cx={702}
        cy={345.9}
        className="ugl_st108"
        rx={1.4}
        ry={2.4}
        transform="rotate(-24.564 702.047 345.957)"
      />
      <path
        d="M732.8 325.9v-7l-8.1 4.2-2.8 13.4 10.9-5.1z"
        className="ugl_st108"
      />
      <path
        d="m743.8 330.6-4.6-2.3c-1.6-.9-3.8-.8-6.2.7-4.8 2.9-8.8 9.8-8.8 15.4 0 2.7.9 4.5 2.3 5.5l5.5 2.8c1.6.8 3.7.6 6-.8 4.8-2.9 8.8-9.8 8.8-15.4 0-3-1.2-5.1-3-5.9z"
        className="ugl_st107"
      />
      <path
        d="m732 352.8-5.5-2.8c-1.4-1-2.3-2.8-2.3-5.5 0-5.6 3.9-12.5 8.8-15.4 2.4-1.5 4.7-1.6 6.2-.7l4.6 2.3"
        className="ugl_st106"
      />
      <path
        d="M731.9 327.1c-4.3 2.2-8 7.4-9.1 12.2l5.5 2.8c1-4.8 4.7-10 9-12.3 1.1-.6 2.1-.9 3-1l-4.1-2.2-4.3.5z"
        className="ugl_st104"
      />
      <ellipse
        cx={738}
        cy={341.7}
        className="ugl_st104"
        rx={12.6}
        ry={7.1}
        transform="rotate(-60.264 738.024 341.755)"
      />
      <ellipse
        cx={738}
        cy={341.7}
        className="ugl_st108"
        rx={7}
        ry={4}
        transform="rotate(-60.264 738.024 341.755)"
      />
      <ellipse
        cx={738}
        cy={341.7}
        className="ugl_st107"
        rx={3.1}
        ry={1.8}
        transform="rotate(-60.264 738.024 341.755)"
      />
      <path
        d="M736.3 326.1c-1.6-.7-3.6-.5-5.9.9-4.1 2.4-7.5 7.7-8.5 12.7l5.3 2.9c.9-5.1 4.4-10.5 8.6-13 2.2-1.3 4.2-1.6 5.7-1l-5.2-2.5z"
        className="ugl_st103"
      />
      <path
        d="M135.8 388.7h-6v11c0 .5 1.3.9 3 .9.5 0 .9 0 1.4-.1 1-.1 1.6-.4 1.6-.8v-11z"
        className="ugl_st131"
      />
      <path
        d="M135.8 393.1c-1 0-2 .1-3 .1s-2 0-2.9-.1v-4.4h6v4.4z"
        className="ugl_st132"
      />
      <path
        d="M135.8 388.7v11c0 .3-.7.6-1.6.8v-11.8h1.6z"
        className="ugl_st132"
      />
      <path
        d="m147.4 386.3-6.8-18.1h-15.8l-6.7 18c0 .1-.1.2-.1.3 0 1.9 6.6 3.4 14.7 3.4h.9c7.7-.1 13.8-1.6 13.8-3.4.1-.1 0-.2 0-.2z"
        className="ugl_st114"
      />
      <path
        d="m140.7 368.2 6.8 18.1c0 .1.1.2.1.3 0 1.8-6.1 3.3-13.8 3.4 0 0 4.3-5 2.8-11.9-1.4-6.1-10.7-8.3-10.7-8.3"
        className="ugl_st133"
      />
      <path
        d="m143.5 367.3-9.3-25.7c-.5-1.4-2.5-1.4-3 0l-9.3 25.7c0 .1-.1.2-.1.3 0 1.6 4.8 2.8 10.8 2.8 6 0 10.8-1.3 10.8-2.8.2-.1.2-.2.1-.3z"
        className="ugl_st114"
      />
      <path
        d="M133.4 340.7c.4.2.7.5.8.9l9.1 25.2c0 .1.1.2.1.3 0 1.4-4 2.5-9.3 2.6 0 0 2.5-2.4 2.5-7.7 0-6.5-3.2-21.3-3.2-21.3z"
        className="ugl_st133"
      />
    </g>
  </svg>
)
export default UnsprayedGroundLarge
